export const InventoryLayoutJSON = [
  {
    json_code: 'instrument',
    json_type_id: '28',
    layout: {
      header: {
        text: {
          value: '',
          defaultValue: 'Instruments',
        },
        showClose: true,
        showPrint: true,
        showDownload: true,
        printText: 'Print',
        downloadText: 'Download AS PDF',
      },
      body: {
        sections: [
          {
            type: 'view-heading-box',
            order: 1,
            value: '',
            valueExpression: '${value1}  <div class="status default-status"></div>  ${value2 ?? "-"}',
            valueExpressionParams: {
              value1: 'inventory_details.inv_master.inv_master_name',
              value2: 'additional_info.status',
            },
            className: 'd-flex ',
            files: 'additional_info.file_ids',
            additionalData: [
              {
                order: 1,
                label: 'Date of Purchase :',
                value: 'additional_info.date_purchase',
              },
              {
                order: 2,
                label: 'Date of Installation :',
                value: 'additional_info.date_installation',
              },
              {
                order: 3,
                label: 'Vendor :',
                value: 'additional_info.vendor.vendor_name',
              },
              {
                order: 4,
                label: 'Catalogue No :',
                value: 'additional_info.catalogue_no',
              },
              {
                order: 5,
                label: 'Product Url :',
                value: 'additional_info.product_url',
              },
            ],
          },
          {
            type: 'header',
            order: 2,
            value: '',
            defaultValue: 'Quality Management',
          },
          {
            type: 'row',
            order: 3,
            contents: [
              {
                order: 1,
                label: 'Quantity (No Of Units)',
                value: 'additional_info.quantity',
                className: 'col-md-3',
              },
              {
                order: 2,
                label: 'IQ,OQ,PQ Status required?',
                value: 'additional_info.iq_oq_pq_status.value',
                className: 'col-md-3',
              },
              {
                order: 3,
                label: 'CMC Status',
                value: '',
                className: 'col-md-3',
                valueExpression: '${value2 ? "Yes":"No"}',
                valueExpressionParams: {
                  value2: 'additional_info.cmc_status',
                },
              },
              {
                order: 4,
                label: 'AMC Status',
                value: '',
                className: 'col-md-3',
                valueExpression: '${value2 ? "Yes":"No"}',
                valueExpressionParams: {
                  value2: 'additional_info.amc_status',
                },
              },
              {
                order: 5,
                label: 'Storage Temperature(°C)',
                value: 'additional_info.storage_temp.value',
                className: 'col-md-3',
              },
              {
                order: 5,
                label: 'Date of Completion',
                value: 'additional_info.date_completion',
                className: 'col-md-3',
                hide: true,
                hideExpression: '${!(value2 == "Yes")}',
                hideExpressionParams: {
                  value2: 'additional_info.iq_oq_pq_status.value',
                },
              },
              {
                order: 5,
                label: 'Status',
                value: 'additional_info.status',
                className: 'col-md-3',
              },
              {
                order: 5,
                label: 'Date of Initiation',
                value: 'additional_info.date_initiation',
                className: 'col-md-3',
              },
              {
                order: 5,
                label: 'Initiation End Date',
                value: 'additional_info.date_initiation_end',
                className: 'col-md-3',
              },
              {
                order: 5,
                label: 'Instrument Location',
                value: 'additional_info.instrument_location',
                className: 'col-md-3',
              },
              {
                order: 5,
                label: 'Serial No',
                value: 'additional_info.serial_no',
                className: 'col-md-3',
              },
              {
                order: 12,
                label: 'Location',
                value: 'inventory_details.location.location',
                className: 'col-md-3',
              },
              {
                order: 6,
                label: 'Description',
                value: 'inventory_details.description',
                className: 'col-md-12',
              },
            ],
          },
          {
            type: 'horizontal',
            order: 4,
          },
        ],
        showButton: true,
        buttonText: 'Back To Listing',
      },
    },
  },
  {
    json_code: 'freezer',
    json_type_id: '36',
    layout: {
      header: {
        text: {
          value: '',
          defaultValue: 'Freezer',
        },
        showClose: true,
        showPrint: true,
        showDownload: true,
        printText: 'Print',
        downloadText: 'Download AS PDF',
      },
      body: {
        sections: [
          {
            type: 'view-heading-box',
            order: 1,
            value: '',
            valueExpression: '${value1}',
            valueExpressionParams: {
              value1: 'inventory_details.inv_item_name',
            },
            className: 'd-flex justify-content-between',
          },
          {
            type: 'header',
            order: 2,
            value: '',
            defaultValue: 'Freezer Information',
          },
          {
            type: 'row',
            order: 3,
            contents: [
              {
                order: 1,
                label: 'Freezer Type',
                value: 'inventory_details.inv_master.inv_master_name',
                className: 'col-md-3',
              },
              {
                order: 1,
                label: 'Model',
                value: 'additional_info.lab_equip_inv_model',
                className: 'col-md-3',
              },
              {
                order: 11,
                label: 'No of Shelves',
                value: 'additional_info.lab_equip_inv_shelves',
                className: 'col-md-3',
              },
              {
                order: 2,
                label: 'Storage Temperature (°C)',
                value: 'inventory_details.inv_master.type_desc.value',
                className: 'col-md-3',
              },
              {
                order: 4,
                label: 'Freezer Name',
                value: 'inventory_details.inv_item_name',
                className: 'col-md-3',
              },
              {
                order: 5,
                label: 'Vendor',
                value: 'additional_info.lab_equip_inv_vendor.vendor_name',
                className: 'col-md-3',
              },
              {
                order: 6,
                label: 'Catalogue No',
                value: 'additional_info.lab_equip_inv_cat_no',
                className: 'col-md-3',
              },
              {
                order: 7,
                label: 'Product Url',
                value: 'additional_info.lab_equip_inv_products_url',
                className: 'col-md-3',
              },
              {
                order: 8,
                label: 'Serial Number',
                value: 'additional_info.lab_equip_inv_serial_no',
                className: 'col-md-3',
              },
              {
                order: 8,
                label: 'Price',
                value: 'additional_info.lab_equip_inv_price',
                className: 'col-md-3',
              },
              {
                order: 8,
                label: 'Currency',
                value: 'additional_info.lab_equip_inv_currency.value',
                className: 'col-md-3',
              },
              {
                order: 9,
                label: 'Purchase Date',
                value: 'additional_info.lab_equip_inv_purchase_date',
                className: 'col-md-3',
              },
              {
                order: 10,
                label: 'Received Date',
                value: 'additional_info.lab_equip_inv_received_date',
                className: 'col-md-3',
              },

              {
                order: 12,
                label: 'Lab Room',
                value: 'additional_info.lab_equip_inv_lab_room',
                className: 'col-md-3',
              },
              {
                order: 12,
                label: 'Location',
                value: 'inventory_details.location.location',
                className: 'col-md-3',
              },
              {
                order: 13,
                label: 'Description/Comments',
                value: 'inventory_details.description',
                className: 'col-md-12',
              },
            ],
          },
          {
            type: 'tab',
            sectionTabList: [
              {
                id: 'box_list',
                title: 'Boxes',
                sections: [
                  {
                    type: 'table',
                    order: 4,
                    columns: [
                      {
                        head: {
                          value: '',
                          defaultValue: 'Name',
                        },
                        field: {
                          value: 'container_name',
                        },
                      },
                      {
                        head: {
                          value: '',
                          defaultValue: 'Type',
                        },
                        field: {
                          key: 'box_type',
                          value: 'type.value',
                        },
                      },
                      {
                        head: {
                          value: '',
                          defaultValue: 'Shelf',
                        },
                        field: {
                          value: 'shelf',
                        },
                      },
                      {
                        head: {
                          value: '',
                          defaultValue: 'Rack',
                        },
                        field: {
                          value: 'rack',
                        },
                      },
                      {
                        head: {
                          value: '',
                          defaultValue: 'Drawer',
                        },
                        field: {
                          value: 'drawer',
                        },
                      },
                    ],
                    showTable: true,
                    noDataMessage: 'No Boxes Found',
                    value: 'additional_info.box_plate_details.box_details',
                  },
                ],
              },
              {
                id: 'plate_list',
                title: 'Plates',
                sections: [
                  {
                    type: 'table',
                    order: 4,
                    columns: [
                      {
                        head: {
                          value: '',
                          defaultValue: 'Name',
                        },
                        field: {
                          value: 'container_name',
                        },
                      },
                      {
                        head: {
                          value: '',
                          defaultValue: 'Type',
                        },
                        field: {
                          key: 'plate_type',
                          value: 'type.value',
                        },
                      },
                      {
                        head: {
                          value: '',
                          defaultValue: 'Shelf',
                        },
                        field: {
                          value: 'shelf',
                        },
                      },
                      {
                        head: {
                          value: '',
                          defaultValue: 'Rack',
                        },
                        field: {
                          value: 'rack',
                        },
                      },
                      {
                        head: {
                          value: '',
                          defaultValue: 'Drawer',
                        },
                        field: {
                          value: 'drawer',
                        },
                      },
                    ],
                    showTable: true,
                    noDataMessage: 'No Plates Found',
                    value: 'additional_info.box_plate_details.plate_details',
                  },
                ],
              },
              {
                id: 'consumable_list',
                title: 'Consumables & Reagents',
                sections: [
                  {
                    type: 'table',
                    order: 4,
                    columns: [
                      {
                        head: {
                          value: '',
                          defaultValue: 'Inventory Item/ Project',
                        },
                        field: {
                          value: 'inv_type_name',
                        },
                      },
                      {
                        head: {
                          value: '',
                          defaultValue: 'Name',
                        },
                        field: {
                          key: 'name',
                          value: '',
                          valueExpression: '${value1 || value2 || value3}',
                          valueExpressionParams: {
                            value1: 'inv_item_name',
                            value2: 'inv_master_name',
                            value3: 'inv_item_code',
                          },
                        },
                      },
                      {
                        head: {
                          value: '',
                          defaultValue: 'Vendor',
                        },
                        field: {
                          key: 'vendor_name',
                          value: '',
                          valueExpression: '${value1 || value2}',
                          valueExpressionParams: {
                            value1: 'vendor.vendor_name',
                            value2: 'vendor_collaborator.value',
                          },
                        },
                      },
                      {
                        head: {
                          value: '',
                          defaultValue: 'No Of Units',
                        },
                        field: {
                          value: 'num_of_units',
                        },
                      },
                    ],
                    showTable: true,
                    noDataMessage: 'No Consumables or Reagents Found',
                    value: 'additional_info.box_plate_details.consumables',
                  },
                ],
              },
            ],
          },
          {
            type: 'horizontal',
            order: 5,
          },
        ],
        showButton: true,
        buttonText: 'Back To Listing',
      },
    },
  },
  {
    json_code: 'refrigerator',
    json_type_id: '37',
    layout: {
      header: {
        text: {
          value: '',
          defaultValue: 'Refrigerator',
        },
        showClose: true,
        showPrint: true,
        showDownload: true,
        printText: 'Print',
        downloadText: 'Download AS PDF',
      },
      body: {
        sections: [
          {
            type: 'view-heading-box',
            order: 1,
            value: '',
            valueExpression: '${value1}',
            valueExpressionParams: {
              value1: 'inventory_details.inv_master.inv_master_name',
            },
            className: 'd-flex justify-content-between',
          },
          {
            type: 'header',
            order: 2,
            value: '',
            defaultValue: 'Refrigerator Information',
          },
          {
            type: 'row',
            order: 3,
            contents: [
              {
                order: 1,
                label: 'Refrigerator Type',
                value: 'inventory_details.inv_master.inv_master_name',
                className: 'col-md-3',
              },
              {
                order: 1,
                label: 'Model',
                value: 'additional_info.lab_equip_inv_model',
                className: 'col-md-3',
              },
              {
                order: 11,
                label: 'No of Shelves',
                value: 'additional_info.lab_equip_inv_shelves',
                className: 'col-md-3',
              },
              {
                order: 2,
                label: 'Storage Temperature (°C)',
                value: 'inventory_details.inv_master.type_desc.value',
                className: 'col-md-3',
              },
              {
                order: 4,
                label: 'Refrigerator Name',
                value: 'inventory_details.inv_item_name',
                className: 'col-md-3',
              },
              {
                order: 5,
                label: 'Vendor',
                value: 'additional_info.lab_equip_inv_vendor.vendor_name',
                className: 'col-md-3',
              },
              {
                order: 6,
                label: 'Catalogue No',
                value: 'additional_info.lab_equip_inv_cat_no',
                className: 'col-md-3',
              },
              {
                order: 7,
                label: 'Product Url',
                value: 'additional_info.lab_equip_inv_products_url',
                className: 'col-md-3',
              },
              {
                order: 8,
                label: 'Serial Number',
                value: 'additional_info.lab_equip_inv_serial_no',
                className: 'col-md-3',
              },
              {
                order: 8,
                label: 'Price',
                value: 'additional_info.lab_equip_inv_price',
                className: 'col-md-3',
              },
              {
                order: 8,
                label: 'Currency',
                value: 'additional_info.lab_equip_inv_currency.value',
                className: 'col-md-3',
              },
              {
                order: 9,
                label: 'Purchase Date',
                value: 'additional_info.lab_equip_inv_purchase_date',
                className: 'col-md-3',
              },
              {
                order: 10,
                label: 'Received Date',
                value: 'additional_info.lab_equip_inv_received_date',
                className: 'col-md-3',
              },

              {
                order: 12,
                label: 'Lab Room',
                value: 'additional_info.lab_equip_inv_lab_room',
                className: 'col-md-3',
              },
              {
                order: 12,
                label: 'Location',
                value: 'inventory_details.location.location',
                className: 'col-md-3',
              },
              {
                order: 13,
                label: 'Description/Comments',
                value: 'inventory_details.description',
                className: 'col-md-12',
              },
            ],
          },
          {
            type: 'tab',
            sectionTabList: [
              {
                id: 'box_list',
                title: 'Boxes',
                sections: [
                  {
                    type: 'table',
                    order: 4,
                    columns: [
                      {
                        head: {
                          value: '',
                          defaultValue: 'Name',
                        },
                        field: {
                          value: 'container_name',
                        },
                      },
                      {
                        head: {
                          value: '',
                          defaultValue: 'Type',
                        },
                        field: {
                          key: 'box_type',
                          value: 'type.value',
                        },
                      },
                      {
                        head: {
                          value: '',
                          defaultValue: 'Shelf',
                        },
                        field: {
                          value: 'shelf',
                        },
                      },
                      {
                        head: {
                          value: '',
                          defaultValue: 'Rack',
                        },
                        field: {
                          value: 'rack',
                        },
                      },
                      {
                        head: {
                          value: '',
                          defaultValue: 'Drawer',
                        },
                        field: {
                          value: 'drawer',
                        },
                      },
                    ],
                    showTable: true,
                    noDataMessage: 'No Boxes Found',
                    value: 'additional_info.box_plate_details.box_details',
                  },
                ],
              },
              {
                id: 'plate_list',
                title: 'Plates',
                sections: [
                  {
                    type: 'table',
                    order: 4,
                    columns: [
                      {
                        head: {
                          value: '',
                          defaultValue: 'Name',
                        },
                        field: {
                          value: 'container_name',
                        },
                      },
                      {
                        head: {
                          value: '',
                          defaultValue: 'Type',
                        },
                        field: {
                          key: 'plate_type',
                          value: 'type.value',
                        },
                      },
                      {
                        head: {
                          value: '',
                          defaultValue: 'Shelf',
                        },
                        field: {
                          value: 'shelf',
                        },
                      },
                      {
                        head: {
                          value: '',
                          defaultValue: 'Rack',
                        },
                        field: {
                          value: 'rack',
                        },
                      },
                      {
                        head: {
                          value: '',
                          defaultValue: 'Drawer',
                        },
                        field: {
                          value: 'drawer',
                        },
                      },
                    ],
                    showTable: true,
                    noDataMessage: 'No Plates Found',
                    value: 'additional_info.box_plate_details.plate_details',
                  },
                ],
              },
              {
                id: 'consumable_list',
                title: 'Consumables & Reagents',
                sections: [
                  {
                    type: 'table',
                    order: 4,
                    columns: [
                      {
                        head: {
                          value: '',
                          defaultValue: 'Inventory Item/ Project',
                        },
                        field: {
                          value: 'inv_type_name',
                        },
                      },
                      {
                        head: {
                          value: '',
                          defaultValue: 'Name',
                        },
                        field: {
                          key: 'name',
                          value: '',
                          valueExpression: '${value1 || value2 || value3}',
                          valueExpressionParams: {
                            value1: 'inv_item_name',
                            value2: 'inv_master_name',
                            value3: 'inv_item_code',
                          },
                        },
                      },
                      {
                        head: {
                          value: '',
                          defaultValue: 'Vendor',
                        },
                        field: {
                          key: 'vendor_name',
                          value: '',
                          valueExpression: '${value1 || value2}',
                          valueExpressionParams: {
                            value1: 'vendor.vendor_name',
                            value2: 'vendor_collaborator.value',
                          },
                        },
                      },
                      {
                        head: {
                          value: '',
                          defaultValue: 'No Of Units',
                        },
                        field: {
                          value: 'num_of_units',
                        },
                      },
                    ],
                    showTable: true,
                    noDataMessage: 'No Consumables or Reagents Found',
                    value: 'additional_info.box_plate_details.consumables',
                  },
                ],
              },
            ],
          },
          {
            type: 'horizontal',
            order: 5,
          },
        ],
        showButton: true,
        buttonText: 'Back To Listing',
      },
    },
  },
  {
    json_code: 'storage-cabinet',
    json_type_id: '38',
    layout: {
      header: {
        text: {
          value: '',
          defaultValue: 'Storage Cabinet',
        },
        showClose: true,
        showPrint: true,
        showDownload: true,
        printText: 'Print',
        downloadText: 'Download AS PDF',
      },
      body: {
        sections: [
          {
            type: 'view-heading-box',
            order: 1,
            value: '',
            valueExpression: '${value1}',
            valueExpressionParams: {
              value1: 'inventory_details.inv_master.inv_master_name',
            },
            className: 'd-flex justify-content-between',
          },
          {
            type: 'header',
            order: 2,
            value: '',
            defaultValue: 'Storage Cabinet Information',
          },
          {
            type: 'row',
            order: 3,
            contents: [
              {
                order: 1,
                label: 'Storage Cabinet Type',
                value: 'inventory_details.inv_master.inv_master_name',
                className: 'col-md-3',
              },
              {
                order: 1,
                label: 'Model',
                value: 'additional_info.lab_equip_inv_model',
                className: 'col-md-3',
              },
              {
                order: 11,
                label: 'No of Shelves',
                value: 'additional_info.lab_equip_inv_shelves',
                className: 'col-md-3',
              },
              {
                order: 2,
                label: 'Storage Temperature (°C)',
                value: 'inventory_details.inv_master.type_desc.value',
                className: 'col-md-3',
              },
              {
                order: 4,
                label: 'Cabinet Name',
                value: 'inventory_details.inv_item_name',
                className: 'col-md-3',
              },
              {
                order: 5,
                label: 'Vendor',
                value: 'additional_info.lab_equip_inv_vendor.vendor_name',
                className: 'col-md-3',
              },
              {
                order: 6,
                label: 'Catalogue No',
                value: 'additional_info.lab_equip_inv_cat_no',
                className: 'col-md-3',
              },
              {
                order: 7,
                label: 'Product Url',
                value: 'additional_info.lab_equip_inv_products_url',
                className: 'col-md-3',
              },
              {
                order: 8,
                label: 'Serial Number',
                value: 'additional_info.lab_equip_inv_serial_no',
                className: 'col-md-3',
              },
              {
                order: 8,
                label: 'Price',
                value: 'additional_info.lab_equip_inv_price',
                className: 'col-md-3',
              },
              {
                order: 8,
                label: 'Currency',
                value: 'additional_info.lab_equip_inv_currency.value',
                className: 'col-md-3',
              },
              {
                order: 9,
                label: 'Purchase Date',
                value: 'additional_info.lab_equip_inv_purchase_date',
                className: 'col-md-3',
              },
              {
                order: 10,
                label: 'Received Date',
                value: 'additional_info.lab_equip_inv_received_date',
                className: 'col-md-3',
              },

              {
                order: 12,
                label: 'Lab Room',
                value: 'additional_info.lab_equip_inv_lab_room',
                className: 'col-md-3',
              },
              {
                order: 12,
                label: 'Location',
                value: 'inventory_details.location.location',
                className: 'col-md-3',
              },
              {
                order: 13,
                label: 'Description/Comments',
                value: 'inventory_details.description',
                className: 'col-md-12',
              },
            ],
          },
          {
            type: 'tab',
            sectionTabList: [
              {
                id: 'box_list',
                title: 'Boxes',
                sections: [
                  {
                    type: 'table',
                    order: 4,
                    columns: [
                      {
                        head: {
                          value: '',
                          defaultValue: 'Name',
                        },
                        field: {
                          value: 'container_name',
                        },
                      },
                      {
                        head: {
                          value: '',
                          defaultValue: 'Type',
                        },
                        field: {
                          key: 'box_type',
                          value: 'type.value',
                        },
                      },
                      {
                        head: {
                          value: '',
                          defaultValue: 'Shelf',
                        },
                        field: {
                          value: 'shelf',
                        },
                      },
                      {
                        head: {
                          value: '',
                          defaultValue: 'Rack',
                        },
                        field: {
                          value: 'rack',
                        },
                      },
                      {
                        head: {
                          value: '',
                          defaultValue: 'Drawer',
                        },
                        field: {
                          value: 'drawer',
                        },
                      },
                    ],
                    showTable: true,
                    noDataMessage: 'No Boxes Found',
                    value: 'additional_info.box_plate_details.box_details',
                  },
                ],
              },
              {
                id: 'plate_list',
                title: 'Plates',
                sections: [
                  {
                    type: 'table',
                    order: 4,
                    columns: [
                      {
                        head: {
                          value: '',
                          defaultValue: 'Name',
                        },
                        field: {
                          value: 'container_name',
                        },
                      },
                      {
                        head: {
                          value: '',
                          defaultValue: 'Type',
                        },
                        field: {
                          key: 'plate_type',
                          value: 'type.value',
                        },
                      },
                      {
                        head: {
                          value: '',
                          defaultValue: 'Shelf',
                        },
                        field: {
                          value: 'shelf',
                        },
                      },
                      {
                        head: {
                          value: '',
                          defaultValue: 'Rack',
                        },
                        field: {
                          value: 'rack',
                        },
                      },
                      {
                        head: {
                          value: '',
                          defaultValue: 'Drawer',
                        },
                        field: {
                          value: 'drawer',
                        },
                      },
                    ],
                    showTable: true,
                    noDataMessage: 'No Plates Found',
                    value: 'additional_info.box_plate_details.plate_details',
                  },
                ],
              },
              {
                id: 'consumable_list',
                title: 'Consumables & Reagents',
                sections: [
                  {
                    type: 'table',
                    order: 4,
                    columns: [
                      {
                        head: {
                          value: '',
                          defaultValue: 'Inventory Item/ Project',
                        },
                        field: {
                          value: 'inv_type_name',
                        },
                      },
                      {
                        head: {
                          value: '',
                          defaultValue: 'Name',
                        },
                        field: {
                          key: 'name',
                          value: '',
                          valueExpression: '${value1 || value2 || value3}',
                          valueExpressionParams: {
                            value1: 'inv_item_name',
                            value2: 'inv_master_name',
                            value3: 'inv_item_code',
                          },
                        },
                      },
                      {
                        head: {
                          value: '',
                          defaultValue: 'Vendor',
                        },
                        field: {
                          key: 'vendor_name',
                          value: '',
                          valueExpression: '${value1 || value2}',
                          valueExpressionParams: {
                            value1: 'vendor.vendor_name',
                            value2: 'vendor_collaborator.value',
                          },
                        },
                      },
                      {
                        head: {
                          value: '',
                          defaultValue: 'No Of Units',
                        },
                        field: {
                          value: 'num_of_units',
                        },
                      },
                    ],
                    showTable: true,
                    noDataMessage: 'No Consumables or Reagents Found',
                    value: 'additional_info.box_plate_details.consumables',
                  },
                ],
              },
            ],
          },
          {
            type: 'horizontal',
            order: 5,
          },
        ],
        showButton: true,
        buttonText: 'Back To Listing',
      },
    },
  },
  {
    json_code: 'shelves',
    json_type_id: '39',
    layout: {
      header: {
        text: {
          value: '',
          defaultValue: 'Shelves',
        },
        showClose: true,
        showPrint: true,
        showDownload: true,
        printText: 'Print',
        downloadText: 'Download AS PDF',
      },
      body: {
        sections: [
          {
            type: 'view-heading-box',
            order: 1,
            value: '',
            valueExpression: '${value1}',
            valueExpressionParams: {
              value1: 'inventory_details.inv_master.inv_master_name',
            },
            className: 'd-flex justify-content-between',
          },
          {
            type: 'header',
            order: 2,
            value: '',
            defaultValue: 'Shelves Information',
          },
          {
            type: 'row',
            order: 3,
            contents: [
              {
                order: 1,
                label: 'Shelves Type',
                value: 'inventory_details.inv_master.inv_master_name',
                className: 'col-md-3',
              },
              //   order: 1,
              //   label: 'Model',
              //   className: 'col-md-3',
              {
                order: 11,
                label: 'No of Shelves',
                value: 'additional_info.str_no_of_shelves',
                className: 'col-md-3',
              },
              {
                order: 2,
                label: 'Storage Temperature (°C)',
                value: 'additional_info.lab_equip_inv_temp',
                className: 'col-md-3',
              },
              {
                order: 4,
                label: 'Shelf Name',
                value: 'inventory_details.inv_item_name',
                className: 'col-md-3',
              },
              {
                order: 5,
                label: 'Vendor',
                value: 'additional_info.lab_equip_inv_vendor.vendor_name',
                className: 'col-md-3',
              },
              {
                order: 6,
                label: 'Catalogue No',
                value: 'additional_info.lab_equip_inv_cat_no',
                className: 'col-md-3',
              },
              {
                order: 7,
                label: 'Product Url',
                value: 'additional_info.lab_equip_inv_products_url',
                className: 'col-md-3',
              },
              {
                order: 8,
                label: 'Serial Number',
                value: 'additional_info.lab_equip_inv_serial_no',
                className: 'col-md-3',
              },
              {
                order: 8,
                label: 'Price',
                value: 'additional_info.lab_equip_inv_price',
                className: 'col-md-3',
              },
              {
                order: 8,
                label: 'Currency',
                value: 'additional_info.lab_equip_inv_currency.value',
                className: 'col-md-3',
              },
              {
                order: 9,
                label: 'Purchase Date',
                value: 'additional_info.lab_equip_inv_purchase_date',
                className: 'col-md-3',
              },
              {
                order: 10,
                label: 'Received Date',
                value: 'additional_info.lab_equip_inv_received_date',
                className: 'col-md-3',
              },

              {
                order: 12,
                label: 'Lab Room',
                value: 'additional_info.lab_equip_inv_lab_room',
                className: 'col-md-3',
              },
              {
                order: 12,
                label: 'Location',
                value: 'inventory_details.location.location',
                className: 'col-md-3',
              },
              {
                order: 13,
                label: 'Description/Comments',
                value: 'inventory_details.description',
                className: 'col-md-12',
              },
            ],
          },
          {
            type: 'tab',
            sectionTabList: [
              {
                id: 'box_list',
                title: 'Boxes',
                sections: [
                  {
                    type: 'table',
                    order: 4,
                    columns: [
                      {
                        head: {
                          value: '',
                          defaultValue: 'Name',
                        },
                        field: {
                          value: 'container_name',
                        },
                      },
                      {
                        head: {
                          value: '',
                          defaultValue: 'Type',
                        },
                        field: {
                          key: 'box_type',
                          value: 'type.value',
                        },
                      },
                      {
                        head: {
                          value: '',
                          defaultValue: 'Shelf',
                        },
                        field: {
                          value: 'shelf',
                        },
                      },
                    ],
                    showTable: true,
                    noDataMessage: 'No Boxes Found',
                    value: 'additional_info.box_plate_details.box_details',
                  },
                ],
              },
              {
                id: 'plate_list',
                title: 'Plates',
                sections: [
                  {
                    type: 'table',
                    order: 4,
                    columns: [
                      {
                        head: {
                          value: '',
                          defaultValue: 'Name',
                        },
                        field: {
                          value: 'container_name',
                        },
                      },
                      {
                        head: {
                          value: '',
                          defaultValue: 'Type',
                        },
                        field: {
                          key: 'plate_type',
                          value: 'type.value',
                        },
                      },
                      {
                        head: {
                          value: '',
                          defaultValue: 'Shelf',
                        },
                        field: {
                          value: 'shelf',
                        },
                      },
                    ],
                    showTable: true,
                    noDataMessage: 'No Plates Found',
                    value: 'additional_info.box_plate_details.plate_details',
                  },
                ],
              },
              {
                id: 'consumable_list',
                title: 'Consumables & Reagents',
                sections: [
                  {
                    type: 'table',
                    order: 4,
                    columns: [
                      {
                        head: {
                          value: '',
                          defaultValue: 'Inventory Item/ Project',
                        },
                        field: {
                          value: 'inv_type_name',
                        },
                      },
                      {
                        head: {
                          value: '',
                          defaultValue: 'Name',
                        },
                        field: {
                          key: 'name',
                          value: '',
                          valueExpression: '${value1 || value2 || value3}',
                          valueExpressionParams: {
                            value1: 'inv_item_name',
                            value2: 'inv_master_name',
                            value3: 'inv_item_code',
                          },
                        },
                      },
                      {
                        head: {
                          value: '',
                          defaultValue: 'Vendor',
                        },
                        field: {
                          key: 'vendor_name',
                          value: '',
                          valueExpression: '${value1 || value2}',
                          valueExpressionParams: {
                            value1: 'vendor.vendor_name',
                            value2: 'vendor_collaborator.value',
                          },
                        },
                      },
                      {
                        head: {
                          value: '',
                          defaultValue: 'No Of Units',
                        },
                        field: {
                          value: 'num_of_units',
                        },
                      },
                    ],
                    showTable: true,
                    noDataMessage: 'No Consumables or Reagents Found',
                    value: 'additional_info.box_plate_details.consumables',
                  },
                ],
              },
            ],
          },
          {
            type: 'horizontal',
            order: 5,
          },
        ],
        showButton: true,
        buttonText: 'Back To Listing',
      },
    },
  },
  {
    json_code: 'assay-kits',
    json_type_id: '29',
    layout: {
      header: {
        text: {
          value: '',
          defaultValue: 'Assay Kits',
        },
        showClose: true,
        showPrint: true,
        showDownload: true,
        printText: 'Print',
        downloadText: 'Download AS PDF',
      },
      body: {
        sections: [
          {
            type: 'view-heading-box',
            order: 1,
            value: 'inventory_details.inv_master.inv_master_name',
            className: 'd-flex justify-content-between',
          },
          {
            type: 'header',
            order: 2,
            value: '',
            defaultValue: 'Assay Kits Information',
          },
          {
            type: 'row',
            order: 3,
            contents: [
              {
                order: 1,
                label: 'No of Units',
                value: 'additional_info.inv_item_quantity',
                className: 'col-md-3',
              },
              {
                order: 2,
                label: 'Vendor',
                value: 'additional_info.vendor.vendor_name',
                className: 'col-md-3',
              },
              {
                order: 4,
                label: 'Catalogue No',
                value: 'additional_info.catelogue_no',
                className: 'col-md-3',
              },
              {
                order: 5,
                label: 'Product Url',
                value: 'additional_info.product_url',
                className: 'col-md-3',
              },
              {
                order: 5,
                label: 'Biosafety Level',
                value: 'additional_info.biosafety_level.value',
                className: 'col-md-3',
              },
              {
                order: 5,
                label: 'Expiry Date',
                value: 'additional_info.expiry_date',
                className: 'col-md-3',
              },
              {
                order: 5,
                label: 'Storage Temperature (°C)',
                value: 'additional_info.storage_temp.value',
                className: 'col-md-3',
              },
              {
                order: 5,
                label: 'Date of Storage',
                value: 'additional_info.date_of_storage',
                className: 'col-md-3',
              },
              {
                order: 12,
                label: 'Location',
                value: 'inventory_details.location.location',
                className: 'col-md-3',
              },

              {
                order: 6,
                label: 'Description',
                value: 'inventory_details.description',
                className: 'col-md-12',
              },
            ],
          },
          {
            type: 'header',
            order: 2,
            value: '',
            defaultValue: 'Assign Storage',
          },
          {
            type: 'storage-table',
            order: 4,
            value: 'additional_info.assigned_storage',
          },
          {
            type: 'horizontal',
            order: 5,
          },
        ],
        showButton: true,
        buttonText: 'Back To Listing',
      },
    },
  },
  {
    json_code: 'cell-culture-media-antibiotics-agar-plates',
    json_type_id: '30',
    layout: {
      header: {
        text: {
          value: '',
          valueExpression: '${value1}',
          valueExpressionParams: {
            value1: 'inventory_details.inv_master.inv_master_name',
            // value2: 'additional_info.source.value',
          },
        },
        showClose: true,
        showPrint: true,
        showDownload: true,
        printText: 'Print',
        downloadText: 'Download AS PDF',
      },
      body: {
        sections: [
          {
            type: 'view-heading-box',
            order: 1,
            value: '',
            valueExpression: '${value1} <div class="status default-status"></div>  ${value2}',
            valueExpressionParams: {
              value1: 'inventory_details.inv_master.type_desc.value',
              value2: 'inventory_details.inv_master.inv_master_name',
            },
            className: 'd-flex ',
          },
          {
            type: 'header',
            order: 2,
            value: '',
            valueExpression: '${value1} Information',
            valueExpressionParams: {
              value1: 'inventory_details.inv_master.type_desc.value',
            },
          },
          {
            type: 'row',
            order: 3,
            contents: [
              {
                order: 1,
                label: 'Form',
                value: '',
                valueExpression: '${value1 == "Agar Plates" ? value2 : value3}',
                valueExpressionParams: {
                  value1: 'inventory_details.inv_master.type_desc.value',
                  value2: 'additional_info.form_agar_plate',
                  value3: 'additional_info.form_other_type.value',
                },
                className: 'col-md-3',
              },
              {
                order: 2,
                label: 'Unit Size',
                value: 'additional_info.inv_item_quantity',
                className: 'col-md-3',
                hide: true,
                hideExpression: '${!(value1 == "Antibiotics")}',
                hideExpressionParams: {
                  value1: 'inventory_details.inv_master.type_desc.value',
                },
              },
              {
                order: 4,
                label: 'Conc (mg/mL)',
                value: 'additional_info.concentration',
                className: 'col-md-3',
                hide: true,
                hideExpression: '${!(value1 == "Antibiotics")}',
                hideExpressionParams: {
                  value1: 'inventory_details.inv_master.type_desc.value',
                },
              },
              {
                order: 5,
                label: 'Quantity (No of Units)',
                value: 'additional_info.inv_item_quantity',
                className: 'col-md-3',
              },
              {
                order: 5,
                label: 'In House Source ID',
                value: 'additional_info.inhouse_id',
                className: 'col-md-3',
                hide: true,
                hideExpression: '${!(value1 == "In House")}',
                hideExpressionParams: {
                  value1: 'additional_info.source.value',
                },
              },
              {
                order: 5,
                label: 'Vendor',
                value: 'additional_info.vendor.vendor_name',
                className: 'col-md-3',
                hide: true,
                hideExpression: '${!(value1 != "Agar Plates" || value2 == "Commercial")}',
                hideExpressionParams: {
                  value1: 'inventory_details.inv_master.type_desc.value',
                  value2: 'additional_info.source.value',
                },
              },
              {
                order: 5,
                label: 'Catalogue No',
                value: 'additional_info.catelogue_no',
                className: 'col-md-3',
                hide: true,
                hideExpression: '${!(value1 != "Agar Plates" || value2 == "Commercial")}',
                hideExpressionParams: {
                  value1: 'inventory_details.inv_master.type_desc.value',
                  value2: 'additional_info.source.value',
                },
              },
              {
                order: 5,
                label: 'Product URL',
                value: 'additional_info.product_url',
                className: 'col-md-3',
                hide: true,
                hideExpression: '${!(value1 != "Agar Plates" || value2 == "Commercial")}',
                hideExpressionParams: {
                  value1: 'inventory_details.inv_master.type_desc.value',
                  value2: 'additional_info.source.value',
                },
              },
              {
                order: 5,
                label: 'Biosafety Level',
                value: 'additional_info.biosafety_level.value',
                className: 'col-md-3',
              },
              {
                order: 5,
                label: 'Shelf Life (Months)',
                value: 'additional_info.shelf_life_months',
                className: 'col-md-3',
                hide: true,
                hideExpression: '${(value1 == "Agar Plates")}',
                hideExpressionParams: {
                  value1: 'inventory_details.inv_master.type_desc.value',
                },
              },
              {
                order: 5,
                label: 'Expiry Date',
                value: 'additional_info.expiry_date',
                className: 'col-md-3',
              },
              {
                order: 5,
                label: 'Storage Temperature (°C)',
                value: 'additional_info.storage_temp.value',
                className: 'col-md-3',
              },
              {
                order: 5,
                label: 'Date of Storage',
                value: 'additional_info.date_of_storage',
                className: 'col-md-3',
              },
              {
                order: 12,
                label: 'Location',
                value: 'inventory_details.location.location',
                className: 'col-md-3',
              },
              {
                order: 6,
                label: 'Description',
                value: 'inventory_details.description',
                className: 'col-md-12',
              },
            ],
          },
          {
            type: 'header',
            order: 2,
            value: '',
            defaultValue: 'Assign Storage',
          },
          {
            type: 'storage-table',
            order: 4,
            value: 'additional_info.assigned_storage',
          },
          {
            type: 'horizontal',
            order: 5,
          },
        ],
        showButton: true,
        buttonText: 'Back To Listing',
      },
    },
  },
  {
    json_code: 'gels-buffers-lab-reagents',
    json_type_id: '40',
    layout: {
      header: {
        text: {
          value: 'inventory_details.inv_master.inv_master_name',
        },
        showClose: true,
        showPrint: true,
        showDownload: true,
        printText: 'Print',
        downloadText: 'Download AS PDF',
      },
      body: {
        sections: [
          {
            type: 'view-heading-box',
            order: 1,
            value: '',
            valueExpression: '${value1} <div class="status default-status"></div> ${value2}',
            valueExpressionParams: {
              value1: 'inventory_details.inv_master.type_desc.value',
              value2: 'inventory_details.inv_master.inv_master_name',
            },
            className: 'd-flex ',
          },
          {
            type: 'header',
            order: 2,
            value: '',
            valueExpression: '${value1} Information',
            valueExpressionParams: {
              value1: 'inventory_details.inv_master.type_desc.value',
            },
          },
          {
            type: 'row',
            order: 3,
            contents: [
              {
                order: 1,
                label: 'Quantity (No of Units)',
                value: 'additional_info.inv_item_quantity',
                className: 'col-md-3',
              },
              //   order: 1,
              //   label: 'Quantity (Box)',
              //   className: 'col-md-3',
              //   hide: true,
              //   hideExpression: '${!(value1 == "Gels")}',
              //   hideExpressionParams: {
              //     value1: 'inventory_details.inv_master.type_desc.value',
              //   order: 1,
              //   label: 'Wells',
              //   className: 'col-md-3',
              //   hide: true,
              //   hideExpression: '${!(value1 == "Gels")}',
              //   hideExpressionParams: {
              //     value1: 'inventory_details.inv_master.type_desc.value',
              {
                order: 1,
                label: 'Form',
                value: 'additional_info.form_other_type.value',
                className: 'col-md-3',
                hide: true,
                hideExpression: '${(value1 == "Gels")}',
                hideExpressionParams: {
                  value1: 'inventory_details.inv_master.type_desc.value',
                },
              },
              {
                order: 1,
                label: 'Volume',
                value: 'additional_info.inv_item_volume',
                className: 'col-md-3',
                hide: true,
                hideExpression: '${(value1 == "Gels")}',
                hideExpressionParams: {
                  value1: 'inventory_details.inv_master.type_desc.value',
                },
              },
              {
                order: 2,
                label: 'Vendor',
                value: 'additional_info.vendor.vendor_name',
                className: 'col-md-3',
              },
              {
                order: 4,
                label: 'Catalogue No',
                value: 'additional_info.catelogue_no',
                className: 'col-md-3',
              },
              {
                order: 5,
                label: 'Product Url',
                value: 'additional_info.product_url',
                className: 'col-md-3',
              },
              {
                order: 5,
                label: 'Biosafety Level',
                value: 'additional_info.biosafety_level.value',
                className: 'col-md-3',
              },
              {
                order: 5,
                label: 'Expiry Date',
                value: 'additional_info.expiry_date',
                className: 'col-md-3',
              },
              {
                order: 5,
                label: 'Storage Temperature (°C)',
                value: 'additional_info.storage_temp.value',
                className: 'col-md-3',
              },
              {
                order: 5,
                label: 'Date of Storage',
                value: 'additional_info.date_of_storage',
                className: 'col-md-3',
              },
              {
                order: 12,
                label: 'Location',
                value: 'inventory_details.location.location',
                className: 'col-md-3',
              },
              {
                order: 6,
                label: 'Description',
                value: 'inventory_details.description',
                className: 'col-md-12',
              },
            ],
          },
          {
            type: 'header',
            order: 2,
            value: '',
            defaultValue: 'Assign Storage',
          },
          {
            type: 'storage-table',
            order: 4,
            value: 'additional_info.assigned_storage',
          },
          {
            type: 'horizontal',
            order: 5,
          },
        ],
        showButton: true,
        buttonText: 'Back To Listing',
      },
    },
  },
  {
    json_code: 'plasticwares',
    json_type_id: '31',
    layout: {
      header: {
        text: {
          value: 'inventory_details.item_type',
        },
        showClose: true,
        showPrint: true,
        showDownload: true,
        printText: 'Print',
        downloadText: 'Download AS PDF',
      },
      body: {
        sections: [
          {
            type: 'view-heading-box',
            order: 1,
            value: 'inventory_details.inv_master.inv_master_name',
            className: 'd-flex justify-content-between',
          },
          {
            type: 'header',
            order: 2,
            value: '',
            valueExpression: '${value1} Information',
            valueExpressionParams: {
              value1: 'inventory_details.item_type',
            },
          },
          {
            type: 'row',
            order: 3,
            contents: [
              {
                order: 1,
                label: 'Usability Type',
                value: 'additional_info.usability_type',
                className: 'col-md-3',
              },
              {
                order: 1,
                label: 'Volume',
                value: 'additional_info.inv_item_volume',
                className: 'col-md-3',
              },
              {
                order: 1,
                label: 'Quantity(No of Units)',
                value: 'additional_info.inv_item_quantity',
                className: 'col-md-3',
              },
              {
                order: 2,
                label: 'Vendor',
                value: 'additional_info.vendor.vendor_name',
                className: 'col-md-3',
              },
              {
                order: 4,
                label: 'Catalogue No',
                value: 'additional_info.catelogue_no',
                className: 'col-md-3',
              },
              {
                order: 5,
                label: 'Product Url',
                value: 'additional_info.product_url',
                className: 'col-md-3',
              },
              {
                order: 5,
                label: 'Biosafety Level',
                value: 'additional_info.biosafety_level.value',
                className: 'col-md-3',
              },
              {
                order: 5,
                label: 'Expiry Date',
                value: 'additional_info.expiry_date',
                className: 'col-md-3',
              },
              {
                order: 5,
                label: 'Storage Temperature (°C)',
                value: 'additional_info.storage_temp.value',
                className: 'col-md-3',
              },
              {
                order: 5,
                label: 'Date of Storage',
                value: 'additional_info.date_of_storage',
                className: 'col-md-3',
              },
              {
                order: 12,
                label: 'Location',
                value: 'inventory_details.location.location',
                className: 'col-md-3',
              },
              {
                order: 6,
                label: 'Description',
                value: 'inventory_details.description',
                className: 'col-md-12',
              },
            ],
          },
          {
            type: 'header',
            order: 2,
            value: '',
            defaultValue: 'Assign Storage',
          },
          {
            type: 'storage-table',
            order: 4,
            value: 'additional_info.assigned_storage',
          },
          {
            type: 'horizontal',
            order: 5,
          },
        ],
        showButton: true,
        buttonText: 'Back To Listing',
      },
    },
  },
  {
    json_code: 'glasswares',
    json_type_id: '32',
    layout: {
      header: {
        text: {
          value: 'inventory_details.item_type',
        },
        showClose: true,
        showPrint: true,
        showDownload: true,
        printText: 'Print',
        downloadText: 'Download AS PDF',
      },
      body: {
        sections: [
          {
            type: 'view-heading-box',
            order: 1,
            value: 'inventory_details.inv_master.inv_master_name',
            className: 'd-flex justify-content-between',
          },
          {
            type: 'header',
            order: 2,
            value: '',
            valueExpression: '${value1} Information',
            valueExpressionParams: {
              value1: 'inventory_details.item_type',
            },
          },
          {
            type: 'row',
            order: 3,
            contents: [
              {
                order: 1,
                label: 'Usability Type',
                value: 'additional_info.usability_type',
                className: 'col-md-3',
              },
              {
                order: 1,
                label: 'Volume',
                value: 'additional_info.inv_item_volume',
                className: 'col-md-3',
              },
              {
                order: 1,
                label: 'Quantity(No of Units)',
                value: 'additional_info.inv_item_quantity',
                className: 'col-md-3',
              },
              {
                order: 2,
                label: 'Vendor',
                value: 'additional_info.vendor.vendor_name',
                className: 'col-md-3',
              },
              {
                order: 4,
                label: 'Catalogue No',
                value: 'additional_info.catelogue_no',
                className: 'col-md-3',
              },
              {
                order: 5,
                label: 'Product Url',
                value: 'additional_info.product_url',
                className: 'col-md-3',
              },
              {
                order: 5,
                label: 'Biosafety Level',
                value: 'additional_info.biosafety_level.value',
                className: 'col-md-3',
              },
              {
                order: 5,
                label: 'Expiry Date',
                value: 'additional_info.expiry_date',
                className: 'col-md-3',
              },
              {
                order: 5,
                label: 'Storage Temperature (°C)',
                value: 'additional_info.storage_temp.value',
                className: 'col-md-3',
              },
              {
                order: 5,
                label: 'Date of Storage',
                value: 'additional_info.date_of_storage',
                className: 'col-md-3',
              },
              {
                order: 12,
                label: 'Location',
                value: 'inventory_details.location.location',
                className: 'col-md-3',
              },
              {
                order: 6,
                label: 'Description',
                value: 'inventory_details.description',
                className: 'col-md-12',
              },
            ],
          },
          {
            type: 'header',
            order: 2,
            value: '',
            defaultValue: 'Assign Storage',
          },
          {
            type: 'storage-table',
            order: 4,
            value: 'additional_info.assigned_storage',
          },
          {
            type: 'horizontal',
            order: 5,
          },
        ],
        showButton: true,
        buttonText: 'Back To Listing',
      },
    },
  },
  {
    json_code: 'plasmids',
    json_type_id: '33',
    layout: {
      header: {
        text: {
          value: '',
          valueExpression: '${value1 + (value2? " - "+value2:"")}',
          valueExpressionParams: {
            value1: 'inventory_details.inv_master.inv_master_name',
            value2: 'additional_info.source.value',
          },
        },
        showClose: true,
        showPrint: true,
        showDownload: true,
        printText: 'Print',
        downloadText: 'Download AS PDF',
      },
      body: {
        sections: [
          {
            type: 'view-heading-box',
            order: 1,
            value: '',
            className: 'd-flex justify-content-between',
            files: 'additional_info.file_ids',
            valueExpression: '${value1 + (value2? " - "+value2:"")}',
            valueExpressionParams: {
              value1: 'inventory_details.inv_master.type_desc.value',
              value2: 'inventory_details.inv_item_name',
            },
            additionalData: [
              {
                order: 1,
                label: 'Plasmid ID :',
                value: 'inventory_details.inv_item_code',
              },
            ],
          },
          {
            type: 'header',
            order: 2,
            value: '',
            defaultValue: 'Plasmid Information',
          },
          {
            type: 'row',
            order: 3,
            contents: [
              {
                order: 1,
                label: 'Vendor',
                value: 'additional_info.vendor.vendor_name',
                className: 'col-md-3',
                hide: true,
                hideExpression: '${!(value1 == "Commercial")}',
                hideExpressionParams: {
                  value1: 'additional_info.source.value',
                },
              },
              {
                order: 2,
                label: 'Catalogue No',
                value: 'additional_info.catalogue_no',
                className: 'col-md-3',
                hide: true,
                hideExpression: '${!(value1 == "Commercial")}',
                hideExpressionParams: {
                  value1: 'additional_info.source.value',
                },
              },
              {
                order: 3,
                label: 'Product URL',
                value: 'additional_info.product_url',
                className: 'col-md-3',
                hide: true,
                hideExpression: '${!(value1 == "Commercial")}',
                hideExpressionParams: {
                  value1: 'additional_info.source.value',
                },
              },
              {
                order: 4,
                label: 'Collaborator Name',
                value: 'additional_info.collaborator.value',
                className: 'col-md-3',
                hide: true,
                hideExpression: '${!(value1 == "Collaborator")}',
                hideExpressionParams: {
                  value1: 'additional_info.source.value',
                },
              },
              {
                order: 5,
                label: 'Collaborator Source ID',
                value: 'additional_info.collaborator_source_id',
                className: 'col-md-3',
                hide: true,
                hideExpression: '${!(value1 == "Collaborator")}',
                hideExpressionParams: {
                  value1: 'additional_info.source.value',
                },
              },
              {
                order: 6,
                label: 'In House Source ID',
                value: 'additional_info.in_house_id',
                className: 'col-md-3',
                hide: true,
                hideExpression: '${!(value1 == "In House")}',
                hideExpressionParams: {
                  value1: 'additional_info.source.value',
                },
              },
              {
                order: 7,
                label: 'Format',
                value: 'additional_info.format.value',
                className: 'col-md-3',
              },
              {
                order: 8,
                label: 'Total No of Tubes',
                value: 'additional_info.total_no_of_tubes',
                className: 'col-md-3',
              },
              {
                order: 9,
                label: 'Quantity per Tube (μg)',
                value: 'additional_info.quantity_per_tube',
                className: 'col-md-3',
              },
              {
                order: 10,
                label: 'Volume (μl)',
                value: 'additional_info.volume',
                className: 'col-md-3',
              },
              {
                order: 11,
                label: 'Conc (μg / μl)',
                value: 'additional_info.concentration',
                className: 'col-md-3',
              },
              {
                order: 12,
                label: 'Biosafety Level',
                value: 'additional_info.biosafety_level.value',
                className: 'col-md-3',
              },
              {
                order: 13,
                label: 'Bacterial Resistance',
                value: 'additional_info.bacterial_resistance.value',
                className: 'col-md-3',
              },
              {
                order: 14,
                label: 'Mammalian Resistance',
                value: 'additional_info.mammalian_resistance.value',
                className: 'col-md-3',
              },
              {
                order: 15,
                label: 'Expiry Date',
                value: 'additional_info.expiry_date',
                className: 'col-md-3',
              },
              {
                order: 16,
                label: 'Storage Temperature (°C)',
                value: 'additional_info.storage_temp.value',
                className: 'col-md-3',
              },
              {
                order: 17,
                label: 'Received Date',
                value: 'additional_info.received_date',
                className: 'col-md-3',
              },
              {
                order: 18,
                label: 'Date of Storage',
                value: 'additional_info.date_of_storage',
                className: 'col-md-3',
              },
              {
                order: 12,
                label: 'Location',
                value: 'inventory_details.location.location',
                className: 'col-md-3',
              },

              {
                order: 19,
                label: 'Description',
                value: 'inventory_details.description',
                className: 'col-md-12',
              },
            ],
          },
          {
            type: 'header',
            order: 2,
            value: '',
            defaultValue: 'Assign Storage',
          },
          {
            type: 'storage-table',
            order: 4,
            value: 'additional_info.assigned_storage',
          },
          {
            type: 'horizontal',
            order: 6,
          },
        ],
        showButton: true,
        buttonText: 'Back To Listing',
      },
    },
  },
  {
    json_code: 'bacterial-strains',
    json_type_id: '34',
    layout: {
      header: {
        text: {
          value: '',

          valueExpression: '${value1 + (value2? " - "+value2:"")}',
          valueExpressionParams: {
            value1: 'inventory_details.inv_master.inv_master_name',
            value2: 'additional_info.source.value',
          },
        },
        showClose: true,
        showPrint: true,
        showDownload: true,
        printText: 'Print',
        downloadText: 'Download AS PDF',
      },
      body: {
        sections: [
          {
            type: 'view-heading-box',
            order: 1,
            value: 'inventory_details.inv_master.inv_master_name',
            className: 'd-flex justify-content-between',
            additionalData: [
              {
                order: 1,
                label: 'BACTERIAL STRAIN ID :',
                value: 'inventory_details.inv_item_id',
              },
            ],
          },

          {
            type: 'header',
            order: 2,
            value: '',
            defaultValue: 'Strain Information',
          },
          {
            type: 'row',
            order: 3,
            contents: [
              {
                order: 1,
                label: 'Vendor',
                value: 'additional_info.vendor.vendor_name',
                className: 'col-md-3',
                hide: true,
                hideExpression: '${!(value1 == "Commercial")}',
                hideExpressionParams: {
                  value1: 'additional_info.source.value',
                },
              },
              {
                order: 2,
                label: 'Catalogue No',
                value: 'additional_info.catalogue_no',
                className: 'col-md-3',
                hide: true,
                hideExpression: '${!(value1 == "Commercial")}',
                hideExpressionParams: {
                  value1: 'additional_info.source.value',
                },
              },
              {
                order: 3,
                label: 'Product URL',
                value: 'additional_info.product_url',
                className: 'col-md-3',
                hide: true,
                hideExpression: '${!(value1 == "Commercial")}',
                hideExpressionParams: {
                  value1: 'additional_info.source.value',
                },
              },

              {
                order: 4,
                label: 'Collaborator Name',
                value: 'additional_info.collaborator.value',
                className: 'col-md-3',
                hide: true,
                hideExpression: '${!(value1 == "Collaborator")}',
                hideExpressionParams: {
                  value1: 'additional_info.source.value',
                },
              },
              {
                order: 5,
                label: 'Collaborator Source ID',
                value: 'additional_info.collaborator_source_id',
                className: 'col-md-3',
                hide: true,
                hideExpression: '${!(value1 == "Collaborator")}',
                hideExpressionParams: {
                  value1: 'additional_info.source.value',
                },
              },
              {
                order: 6,
                label: 'In House Source ID',
                value: 'additional_info.in_house_id',
                className: 'col-md-3',
                hide: true,
                hideExpression: '${!(value1 == "In House")}',
                hideExpressionParams: {
                  value1: 'additional_info.source.value',
                },
              },
              {
                order: 7,
                label: 'Format',
                value: 'additional_info.format.value',
                className: 'col-md-3',
              },
              {
                order: 8,
                label: 'Total No of Tubes',
                value: 'additional_info.inv_item_quantity',
                className: 'col-md-3',
              },
              {
                order: 9,
                label: 'Volume Per Tube(μl)',
                value: 'additional_info.inv_item_volume',
                className: 'col-md-3',
              },
              {
                order: 11,
                label: 'Biosafety Level',
                value: 'additional_info.biosafety_level.value',
                className: 'col-md-3',
              },
              {
                order: 13,
                label: 'Expiry Date',
                value: 'additional_info.expiry_date',
                className: 'col-md-3',
              },
              {
                order: 14,
                label: 'Storage Temperature (°C)',
                value: 'additional_info.storage_temp.value',
                className: 'col-md-3',
              },
              {
                order: 15,
                label: 'Received Date',
                value: 'additional_info.received_date',
                className: 'col-md-3',
              },
              {
                order: 16,
                label: 'Date of Storage',
                value: 'additional_info.date_of_storage',
                className: 'col-md-3',
              },

              {
                order: 12,
                label: 'Location',
                value: 'inventory_details.location.location',
                className: 'col-md-3',
              },
              {
                order: 17,
                label: 'Description',
                value: 'inventory_details.description',
                className: 'col-md-12',
              },
            ],
          },
          {
            type: 'header',
            order: 4,
            value: '',
            defaultValue: 'Assign Storage',
          },
          {
            type: 'storage-table',
            order: 5,
            value: 'additional_info.assigned_storage',
          },
          {
            type: 'horizontal',
            order: 6,
          },
        ],
        showButton: true,
        buttonText: 'Back To Listing',
      },
    },
  },
  {
    json_code: 'cell-lines',
    json_type_id: '35_xx',
    layout: {
      header: {
        text: {
          value: '',

          valueExpression: '${value1 + (value2? " - "+value2:"")}',
          valueExpressionParams: {
            value1: 'inventory_details.inv_master.inv_master_name',
            value2: 'additional_info.source.value',
          },
        },
        showClose: true,
        showPrint: true,
        showDownload: true,
        printText: 'Print',
        downloadText: 'Download AS PDF',
      },
      body: {
        sections: [
          {
            type: 'view-heading-box',
            order: 1,
            value: 'inventory_details.inv_master.inv_master_name',
            className: 'd-flex justify-content-between',
            additionalData: [
              {
                order: 1,
                label: 'Cell Line ID :',
                value: 'inventory_details.inv_item_id',
              },
            ],
          },

          {
            type: 'header',
            order: 2,
            value: '',
            defaultValue: 'Cell Line  Information',
          },
          {
            type: 'row',
            order: 3,
            contents: [
              {
                order: 1,
                label: 'Vendor',
                value: 'additional_info.vendor.vendor_name',
                className: 'col-md-3',
                hide: true,
                hideExpression: '${!(value1 == "Commercial")}',
                hideExpressionParams: {
                  value1: 'additional_info.source.value',
                },
              },
              {
                order: 2,
                label: 'Catalogue No',
                value: 'additional_info.catalogue_no',
                className: 'col-md-3',
                hide: true,
                hideExpression: '${!(value1 == "Commercial")}',
                hideExpressionParams: {
                  value1: 'additional_info.source.value',
                },
              },
              {
                order: 3,
                label: 'Product URL',
                value: 'additional_info.product_url',
                className: 'col-md-3',
                hide: true,
                hideExpression: '${!(value1 == "Commercial")}',
                hideExpressionParams: {
                  value1: 'additional_info.source.value',
                },
              },
              {
                order: 4,
                label: 'Collaborator Name',
                value: 'additional_info.collaborator.value',
                className: 'col-md-3',
                hide: true,
                hideExpression: '${!(value1 == "Collaborator")}',
                hideExpressionParams: {
                  value1: 'additional_info.source.value',
                },
              },
              {
                order: 5,
                label: 'Collaborator Source ID',
                value: 'additional_info.collaborator_source_id',
                className: 'col-md-3',
                hide: true,
                hideExpression: '${!(value1 == "Collaborator")}',
                hideExpressionParams: {
                  value1: 'additional_info.source.value',
                },
              },
              {
                order: 6,
                label: 'In House Source ID',
                value: 'additional_info.in_house_id',
                className: 'col-md-3',
                hide: true,
                hideExpression: '${!(value1 == "In House Created" || value1 == "In House Expanded" )}',
                hideExpressionParams: {
                  value1: 'additional_info.source.value',
                },
              },
              {
                order: 7,
                label: 'Format',
                value: 'additional_info.format.value',
                className: 'col-md-3',
              },
              {
                order: 8,
                label: 'Total No. of Vials',
                value: 'additional_info.no_of_vials',
                className: 'col-md-3',
              },
              {
                order: 9,
                label: 'Volume per Vial (uL)',
                value: 'additional_info.volume_per_vial',
                className: 'col-md-3',
              },

              {
                order: 10,
                label: 'Total Cell Count(10^6)',
                value: 'additional_info.total_cell_count',
                className: 'col-md-3',
              },
              {
                order: 11,
                label: 'Viability %',
                value: 'additional_info.viability',
                className: 'col-md-3',
              },
              {
                order: 12,
                label: 'Biosafety Level',
                value: 'additional_info.biosafety_level.value',
                className: 'col-md-3',
              },
              {
                order: 13,
                label: 'Mammalian Resistance',
                value: 'additional_info.mammalian_resistance.value',
                className: 'col-md-3',
              },

              {
                order: 14,
                label: 'Expiry Date',
                value: 'additional_info.expiry_date',
                className: 'col-md-3',
              },
              {
                order: 15,
                label: 'Storage Temperature (°C)',
                value: 'additional_info.storage_temp.value',
                className: 'col-md-3',
              },
              {
                order: 16,
                label: 'Received Date',
                value: 'additional_info.received_date',
                className: 'col-md-3',
              },
              {
                order: 17,
                label: 'Date of Storage',
                value: 'additional_info.date_of_storage',
                className: 'col-md-3',
              },

              {
                order: 18,
                label: 'Description',
                value: 'inventory_details.description',
                className: 'col-md-12',
              },
            ],
          },
          {
            type: 'header',
            order: 2,
            value: '',
            defaultValue: 'Assign Storage',
          },
          {
            type: 'storage-table',
            order: 4,
            value: 'additional_info.assigned_storage',
          },
          {
            type: 'horizontal',
            order: 6,
          },
        ],
        showButton: true,
        buttonText: 'Back To Listing',
      },
    },
  },
  {
    json_code: 'vectors',
    json_type_id: '52',
    layout: {
      header: {
        text: {
          value: '',
          defaultValue: 'Vectors',
        },
        showClose: true,
        showPrint: true,
        showDownload: true,
        printText: 'Print',
        downloadText: 'Download AS PDF',
      },
      body: {
        sections: [
          {
            type: 'view-heading-box',
            order: 1,
            value: '',
            hide: true,
            className: 'd-flex ',
            files: 'additional_info.file_ids',
          },
          {
            type: 'header',
            order: 2,
            value: '',
            defaultValue: 'Vector Information',
          },
          {
            type: 'row',
            order: 3,
            contents: [
              {
                order: 1,
                label: 'Vector Name',
                value: 'inventory_details.inv_item_name',
                className: 'col-md-3',
              },
              {
                order: 2,
                label: 'No of Cut Sites',
                value: 'additional_info.no_of_cut_sites',
                className: 'col-md-3',
              },
              {
                order: 3,
                label: 'No Of Insertion Sites',
                value: 'additional_info.no_of_insertion_sites',
                className: 'col-md-3',
              },
              {
                order: 4,
                label: 'Insertion Sites',
                value: '',
                className: 'col-md-3',
                valueExpression: '${value2.join(", ")}',
                valueExpressionParams: {
                  value2: 'additional_info.insertion_sites[*].insertion_sites',
                },
              },
              {
                order: 5,
                label: 'Resistance',
                value: 'additional_info.resistance.value',
                className: 'col-md-3',
              },
              {
                order: 6,
                label: 'Copy',
                value: 'additional_info.copy.value',
                className: 'col-md-3',
              },
              {
                order: 12,
                label: 'Location',
                value: 'inventory_details.location.location',
                className: 'col-md-3',
              },
              {
                order: 7,
                label: 'Notes/Comments',
                value: 'inventory_details.description',
                className: 'col-md-12',
              },
            ],
          },
          {
            type: 'horizontal',
            order: 4,
          },
        ],
        showButton: true,
        buttonText: 'Back To Listing',
      },
    },
  },
  {
    json_code: 'constructs',
    json_type_id: '53',
    layout: {
      header: {
        text: {
          value: '',
          defaultValue: 'Constructs',
        },
        showClose: true,
        showPrint: true,
        showDownload: true,
        printText: 'Print',
        downloadText: 'Download AS PDF',
      },
      body: {
        sections: [
          {
            type: 'view-heading-box',
            order: 1,
            value: '',
            valueExpression: 'Construct ID: ${value2 || "-"}',
            valueExpressionParams: {
              value2: 'inventory_details.inv_item_code',
            },
            className: 'd-flex justify-content-between',
            files: 'additional_info.file_ids',
          },

          {
            type: 'header',
            order: 2,
            value: '',
            defaultValue: 'Vector Information',
          },
          {
            type: 'row',
            order: 3,
            contents: [
              {
                order: 1,
                label: 'Vector Name',
                value: 'additional_info.vector_name.inv_item_name',
                className: 'col-md-3',
              },
              {
                order: 2,
                label: 'No. Of Cut Sites',
                value: 'additional_info.vector_name.no_of_cut_sites',
                className: 'col-md-3',
              },
              {
                order: 3,
                label: 'No. Of insertion sites',
                value: 'additional_info.vector_name.no_of_insertion_sites',
                className: 'col-md-3',
              },
              {
                order: 4,
                label: 'Insertion Sites',
                value: '',
                className: 'col-md-3',
                valueExpression: '${value2?.filter(v=>v).join(", ") || ""}',
                valueExpressionParams: {
                  value2: 'additional_info.insertion_sites[*].insertion_sites',
                },
              },
              {
                order: 5,
                label: 'Resistance',
                value: 'additional_info.vector_name.resistance.value',
                className: 'col-md-3',
              },

              {
                order: 6,
                label: 'Copy',
                value: 'additional_info.vector_name.copy.value',
                className: 'col-md-3',
              },
            ],
          },
          {
            type: 'header',
            order: 4,
            value: '',
            defaultValue: 'Construct Design Information',
          },
          {
            type: 'row',
            order: 5,
            contents: [
              {
                order: 1,
                label: 'Designer',
                value: 'additional_info.designer.value',
                className: 'col-md-3',
              },
              {
                order: 2,
                label: 'Design ID',
                value: 'additional_info.designer_id',
                className: 'col-md-3',
              },
              {
                order: 3,
                label: 'Chain',
                value: 'additional_info.chain.value',
                className: 'col-md-3',
              },
              {
                order: 4,
                label: 'Order Location',
                value: 'additional_info.order_location.value',
                className: 'col-md-3',
              },
              {
                order: 5,
                label: 'Order Date',
                value: 'additional_info.order_date',
                className: 'col-md-3',
              },
              {
                order: 6,
                label: 'Paratope(s)',
                value: '',
                className: 'col-md-3',
                valueExpression: '${value2?.filter(v=>v).join(", ") || ""}',
                valueExpressionParams: {
                  value2: 'additional_info.paratope[*].inv_item_code',
                },
              },
              {
                order: 7,
                label: 'Format',
                value: 'additional_info.format.value',
                className: 'col-md-3',
              },
              {
                order: 8,
                label: 'Source',
                value: 'additional_info.source',
                className: 'col-md-3',
              },
              {
                order: 9,
                label: 'Insert length',
                value: 'additional_info.insert_length',
                className: 'col-md-3',
              },
              {
                order: 10,
                label: 'Description',
                value: 'additional_info.construct_description',
                className: 'col-md-12',
              },
              {
                order: 11,
                label: 'Insert Sequence',
                value: 'additional_info.insert_sequence',
                className: 'col-md-12',
              },
              {
                order: 12,
                label: 'Construct Sequence',
                value: 'additional_info.construct_sequence',
                className: 'col-md-12',
              },
            ],
          },
          {
            type: 'header',
            order: 6,
            value: '',
            defaultValue: 'Construct Batch Zero Information',
          },
          {
            type: 'row',
            order: 7,
            contents: [
              {
                order: 6,
                label: 'Format',
                value: 'additional_info.batch_zero_format.value',
                className: 'col-md-3',
              },
              {
                order: 1,
                label: 'Volume Received (µL)',
                value: 'additional_info.volume_received',
                className: 'col-md-3',
                hide: true,
                hideExpression: '${(value1 == "Freeze Dried")}',
                hideExpressionParams: {
                  value1: 'additional_info.batch_zero_format.value',
                },
              },
              {
                order: 2,
                label: 'DNA CONC(ng/µL)',
                value: 'additional_info.dna',
                className: 'col-md-3',
                hide: true,
                hideExpression: '${(value1 == "Freeze Dried")}',
                hideExpressionParams: {
                  value1: 'additional_info.batch_zero_format.value',
                },
              },
              {
                order: 1,
                label: 'Vol used for Solubilization (µL)',
                value: 'additional_info.volume_used',
                className: 'col-md-3',
                hide: true,
                hideExpression: '${(value1 == "Liquid")}',
                hideExpressionParams: {
                  value1: 'additional_info.batch_zero_format.value',
                },
              },
              {
                order: 2,
                label: 'DNA Amount Received(ng)',
                value: 'additional_info.dna_amount',
                className: 'col-md-3',
                hide: true,
                hideExpression: '${(value1 == "Liquid")}',
                hideExpressionParams: {
                  value1: 'additional_info.batch_zero_format.value',
                },
              },
              {
                order: 2,
                label: 'DNA CONC(ng/ul)',
                value: 'additional_info.dna_conc',
                className: 'col-md-3',
                hide: true,
                hideExpression: '${(value1 == "Liquid")}',
                hideExpressionParams: {
                  value1: 'additional_info.batch_zero_format.value',
                },
              },
              {
                order: 3,
                label: 'Received Date',
                value: 'additional_info.received_date',
                className: 'col-md-3',
              },
              {
                order: 4,
                label: 'Plate ID',
                value: 'additional_info.plate_id',
                className: 'col-md-3',
              },
              {
                order: 5,
                label: 'Storage Container',
                value: 'additional_info.storage_container.value',
                className: 'col-md-3',
              },
             
              //   order: 7,
              //   label: 'Biosafety Level',
              //   className: 'col-md-3',
              {
                order: 8,
                label: 'Storage Temp (°C)',
                value: 'additional_info.storage_temp.value',
                className: 'col-md-3',
              },
              {
                order: 9,
                label: 'No. Of vials/ Plates',
                value: 'additional_info.no_of_vials',
                className: 'col-md-3',
              },
            ],
          },
          {
            type: 'header',
            order: 8,
            value: '',
            defaultValue: 'Construct Batch Information',
          },
          {
            type: 'array',
            order: 9,
            value: 'additional_info.batch_info',
            sections: [
              {
                type: 'sub-header',
                order: 1,
                value: '',
                valueExpression: 'Batch ${value1}',
                valueExpressionParams: {
                  value1: 'batch_no',
                },
                className: 'batch-heading',
              },
              {
                type: 'row',
                order: 2,
                contents: [
                  {
                    order: 1,
                    label: 'Batch ID',
                    value: 'batch_id',
                    className: 'col-md-3',
                  },
                  {
                    order: 2,
                    label: 'Total Volume Purified (uL)',
                    value: 'tot_vol_purified',
                    className: 'col-md-3',
                  },
                  {
                    order: 3,
                    label: 'DNA Conc (ng/µL)',
                    value: 'dna',
                    className: 'col-md-3',
                  },
                  {
                    order: 4,
                    label: 'Vol of Culture Purified (ml)',
                    value: 'vol_culture_purified',
                    className: 'col-md-3',
                  },
                  {
                    order: 5,
                    label: 'Purification Kit',
                    value: 'purification_kit',
                    className: 'col-md-3',
                  },
                  {
                    order: 6,
                    label: 'Storage Container',
                    value: 'storage_container.value',
                    className: 'col-md-3',
                  },
                  {
                    order: 7,
                    label: 'Format',
                    value: 'format.value',
                    className: 'col-md-3',
                  },
                  //   order: 6,
                  //   label: 'Biosafety Level',
                  //   className: 'col-md-3',
                  {
                    order: 8,
                    label: 'Storage Temp (°C)',
                    value: 'storage_temp.value',
                    className: 'col-md-3',
                  },
                  {
                    order: 9,
                    label: 'No. Of vials/ Plates',
                    value: 'no_of_vials',
                    className: 'col-md-3',
                  },
                  {
                    order: 10,
                    label: 'Aliquot Volume per Vial (µL)',
                    value: 'aliquot_volume',
                    className: 'col-md-3',
                  },
                  {
                    order: 11,
                    label: 'Batch Date',
                    value: 'batch_date',
                    className: 'col-md-3',
                  },
                ],
              },
              {
                type: 'header',
                order: 3,
                value: '',
                defaultValue: 'Assign Storage',
              },
              {
                type: 'storage-table',
                order: 4,
                value: 'assigned_storage',
                transformAssignStorageData: false,
                subTypeField: 'sub_item',
                subTypeHead: 'Vials/ Plates',
              },
            ],
            no_data: 'No batches have been generated.',
          },
          {
            type: 'horizontal',
            order: 6,
          },
          {
            type: 'row',
            order: 10,
            contents: [
              {
                order: 12,
                label: 'Location',
                value: 'inventory_details.location.location',
                className: 'col-md-3',
              },
              {
                order: 1,
                label: 'Notes/Comments',
                value: 'inventory_details.description',
                className: 'col-md-12',
              },
            ],
          },
        ],
        showButton: true,
        buttonText: 'Back To Listing',
      },
    },
    layout_master: {
      header: {
        text: {
          value: '',
          defaultValue: 'Constructs',
        },
        showClose: true,
        showPrint: true,
        showDownload: true,
        printText: 'Print',
        downloadText: 'Download AS PDF',
      },
      body: {
        sections: [
          {
            type: 'view-heading-box',
            order: 1,
            value: '',
            valueExpression: 'Construct ID: ${value2 || "-"}',
            valueExpressionParams: {
              value2: 'master_details.inv_master_code',
            },
            className: 'd-flex justify-content-between',
            files: 'additional_info.file_ids',
          },

          {
            type: 'header',
            order: 2,
            value: '',
            defaultValue: 'Vector Information',
          },
          {
            type: 'row',
            order: 3,
            contents: [
              {
                order: 1,
                label: 'Vector Name',
                value: 'additional_info.vector_name.inv_item_name',
                className: 'col-md-3',
              },
              {
                order: 2,
                label: 'No. Of Cut Sites',
                value: 'additional_info.vector_name.no_of_cut_sites',
                className: 'col-md-3',
              },
              {
                order: 3,
                label: 'No. Of insertion sites',
                value: 'additional_info.vector_name.no_of_insertion_sites',
                className: 'col-md-3',
              },
              {
                order: 4,
                label: 'Insertion Sites',
                value: '',
                className: 'col-md-3',
                valueExpression: '${value2?.filter(v=>v).join(", ") || ""}',
                valueExpressionParams: {
                  value2: 'additional_info.insertion_sites[*].insertion_sites',
                },
              },
              {
                order: 5,
                label: 'Resistance',
                value: 'additional_info.vector_name.resistance.value',
                className: 'col-md-3',
              },
              {
                order: 6,
                label: 'Copy',
                value: 'additional_info.vector_name.copy.value',
                className: 'col-md-3',
              },
            ],
          },
          {
            type: 'header',
            order: 4,
            value: '',
            defaultValue: 'Construct Design Information',
          },
          {
            type: 'row',
            order: 5,
            contents: [
              {
                order: 1,
                label: 'Designer',
                value: 'additional_info.designer.value',
                className: 'col-md-3',
              },
              {
                order: 2,
                label: 'Design ID',
                value: 'additional_info.designer_id',
                className: 'col-md-3',
              },
              
              {
                order: 3,
                label: 'Chain',
                value: 'additional_info.chain.value',
                className: 'col-md-3',
              },
              {
                order: 4,
                label: 'Order Location',
                value: 'additional_info.order_location.value',
                className: 'col-md-3',
              },
              {
                order: 5,
                label: 'Order Date',
                value: 'additional_info.order_date',
                className: 'col-md-3',
              },
              {
                order: 6,
                label: 'Paratope(s)',
                value: '',
                className: 'col-md-3',
                valueExpression: '${value2?.filter(v=>v).join(", ") || ""}',
                valueExpressionParams: {
                  value2: 'additional_info.paratope[*].inv_item_code',
                },
              },
              {
                order: 7,
                label: 'Format',
                value: 'additional_info.format.value',
                className: 'col-md-3',
              },
              {
                order: 8,
                label: 'Source',
                value: 'additional_info.source',
                className: 'col-md-3',
              },
              {
                order: 9,
                label: 'Insert length',
                value: 'additional_info.insert_length',
                className: 'col-md-3',
              },
              {
                order: 10,
                label: 'Description',
                value: 'additional_info.construct_description',
                className: 'col-md-12',
              },
              {
                order: 11,
                label: 'Insert Sequence',
                value: 'additional_info.insert_sequence',
                className: 'col-md-12',
              },
              {
                order: 12,
                label: 'Construct Sequence',
                value: 'additional_info.construct_sequence',
                className: 'col-md-12',
              },
            ],
          },
          {
            type: 'header',
            order: 6,
            value: '',
            defaultValue: 'Construct Batch Zero Information',
          },
          {
            type: 'row',
            order: 7,
            contents: [
              {
                order: 6,
                label: 'Format',
                value: 'additional_info.batch_zero_format.value',
                className: 'col-md-3',
              },
              {
                order: 1,
                label: 'Volume Received (µL)',
                value: 'additional_info.volume_received',
                className: 'col-md-3',
                hide: true,
                hideExpression: '${(value1 == "Freeze Dried")}',
                hideExpressionParams: {
                  value1: 'additional_info.batch_zero_format.value',
                },
              },
              {
                order: 2,
                label: 'DNA CONC(ng/µL)',
                value: 'additional_info.dna',
                className: 'col-md-3',
                hide: true,
                hideExpression: '${(value1 == "Freeze Dried")}',
                hideExpressionParams: {
                  value1: 'additional_info.batch_zero_format.value',
                },
              },
            
              {
                order: 1,
                label: 'Vol used for Solubilization (µL)',
                value: 'additional_info.volume_used',
                className: 'col-md-3',
                hide: true,
                hideExpression: '${(value1 == "Liquid")}',
                hideExpressionParams: {
                  value1: 'additional_info.batch_zero_format.value',
                },
              },
              {
                order: 2,
                label: 'DNA Amount Received(ng)',
                value: 'additional_info.dna_amount',
                className: 'col-md-3',
                hide: true,
                hideExpression: '${(value1 == "Liquid")}',
                hideExpressionParams: {
                  value1: 'additional_info.batch_zero_format.value',
                },
              },
              {
                order: 2,
                label: 'DNA CONC(ng/ul)',
                value: 'additional_info.dna_conc',
                className: 'col-md-3',
                hide: true,
                hideExpression:  '${(value1 == "Liquid")}',
                hideExpressionParams: {
                  value1: 'additional_info.batch_zero_format.value',
                },
              },
              {
                order: 3,
                label: 'Received Date',
                value: 'additional_info.received_date',
                className: 'col-md-3',
              },
              {
                order: 4,
                label: 'Plate ID',
                value: 'additional_info.plate_id',
                className: 'col-md-3',
              },
              {
                order: 5,
                label: 'Storage Container',
                value: 'additional_info.storage_container.value',
                className: 'col-md-3',
              },

              //   order: 7,
              //   label: 'Biosafety Level',
              //   className: 'col-md-3',
              {
                order: 8,
                label: 'Storage Temp (°C)',
                value: 'additional_info.storage_temp.value',
                className: 'col-md-3',
              },
              {
                order: 9,
                label: 'No. Of vials/ Plates',
                value: 'additional_info.no_of_vials',
                className: 'col-md-3',
              },
            ],
          },
          {
            type: 'header',
            order: 8,
            value: '',
            defaultValue: 'Assign Storage',
          },
          {
            type: 'storage-table',
            order: 9,
            value: 'additional_info.assigned_storage',
            transformAssignStorageData: false
          },
          {
            type: 'horizontal',
            order: 6,
          },
          {
            type: 'row',
            order: 10,
            contents: [
              {
                order: 12,
                label: 'Location',
                value: 'master_details.location.location',
                className: 'col-md-3',
              },
              {
                order: 1,
                label: 'Notes/Comments',
                value: 'master_details.desc',
                className: 'col-md-12',
              },
            ],
          },
        ],
        showButton: true,
        buttonText: 'Back To Listing',
      },
    },
    batch_info_layout: {
      header: {
        text: {
          value: '',
          valueExpression: '${value1 +" - No of Batches "+ value2.length}',
          valueExpressionParams: {
            value1: 'inventory_details.inv_item_code',
            value2: 'additional_info.batch_info',
          },
          defaultValue: 'Constructs',
        },
        showClose: true,
        showPrint: false,
        showDownload: false,
        printText: 'Print',
        downloadText: 'Download AS PDF',
      },
      body: {
        sections: [
          {
            type: 'header',
            order: 1,
            value: '',
            defaultValue: 'Construct Batch Info',
          },
          {
            type: 'array',
            order: 2,
            value: 'additional_info.batch_info',
            sections: [
              {
                type: 'sub-header',
                order: 1,
                value: '',
                valueExpression: 'Batch ${value1}',
                valueExpressionParams: {
                  value1: 'batch_no',
                },
                className: 'batch-heading',
              },
              {
                type: 'row',
                order: 2,
                contents: [
                  {
                    order: 1,
                    label: 'Batch ID',
                    value: 'batch_id',
                    className: 'col-md-3',
                  },
                  {
                    order: 2,
                    label: 'Total Volume Purified (uL)',
                    value: 'tot_vol_purified',
                    className: 'col-md-3',
                  },
                  {
                    order: 3,
                    label: 'DNA Conc (ng/µL)',
                    value: 'dna',
                    className: 'col-md-3',
                  },
                  {
                    order: 4,
                    label: 'Vol of Culture Purified (ml)',
                    value: 'vol_culture_purified',
                    className: 'col-md-3',
                  },
                  {
                    order: 5,
                    label: 'Purification Kit',
                    value: 'purification_kit',
                    className: 'col-md-3',
                  },
                  {
                    order: 6,
                    label: 'Storage Container',
                    value: 'storage_container.value',
                    className: 'col-md-3',
                  },
                  {
                    order: 7,
                    label: 'Format',
                    value: 'format.value',
                    className: 'col-md-3',
                  },
                  //   order: 6,
                  //   label: 'Biosafety Level',
                  //   className: 'col-md-3',
                  {
                    order: 8,
                    label: 'Storage Temp (°C)',
                    value: 'storage_temp.value',
                    className: 'col-md-3',
                  },
                  {
                    order: 9,
                    label: 'No. Of vials/ Plates',
                    value: 'no_of_vials',
                    className: 'col-md-3',
                  },
                  {
                    order: 10,
                    label: 'Aliquot Volume per Vial (µL)',
                    value: 'aliquot_volume',
                    className: 'col-md-3',
                  },
                  {
                    order: 11,
                    label: 'Batch Date',
                    value: 'batch_date',
                    className: 'col-md-3',
                  },
                ],
              },
              {
                type: 'header',
                order: 3,
                value: '',
                defaultValue: 'Assign Storage',
              },
              {
                type: 'storage-table',
                order: 4,
                value: 'assigned_storage',
                transformAssignStorageData: false,
                subTypeField: 'sub_item',
                subTypeHead: 'Vials/ Plates',
              },
            ],
            no_data: 'No batches have been generated.',
          },
          {
            type: 'horizontal',
            order: 6,
          },
          {
            type: 'row',
            order: 10,
            contents: [
              {
                order: 12,
                label: 'Location',
                value: 'inventory_details.location.location',
                className: 'col-md-3',
              },
              {
                order: 1,
                label: 'Notes/Comments',
                value: 'inventory_details.description',
                className: 'col-md-12',
              },
            ],
          },
        ],
        showButton: true,
        buttonText: 'Back To Listing',
      },
    },
  },
  {
    json_code: 'paratope',
    json_type_id: '54',
    layout: {
      header: {
        text: {
          value: '',
          defaultValue: 'Paratope',
        },
        showClose: true,
        showPrint: true,
        showDownload: true,
        printText: 'Print',
        downloadText: 'Download AS PDF',
      },
      body: {
        sections: [
          {
            type: 'view-heading-box',
            order: 1,
            value: '',
            valueExpression: 'Paratope ID: ${value2 || "-"}',
            valueExpressionParams: {
              value2: 'inventory_details.inv_item_code',
            },
            className: 'd-flex justify-content-between',
            files: 'additional_info.file_ids',
          },

          {
            type: 'header',
            order: 2,
            value: '',
            defaultValue: 'Paratope Information',
          },
          {
            type: 'row',
            order: 5,
            contents: [
              {
                order: 1,
                label: 'Project /Selection ID',
                value: '',
                className: 'col-md-3',
                valueExpression: '${value1 || value2}',
                valueExpressionParams: {
                  value1: 'additional_info.project_selection_id.project_instance_code',
                  value2: 'additional_info.selection_id',
                },
                hideExpression: '${(value1 == "External")}',
                hideExpressionParams: {
                  value1: 'additional_info.paratope_type.value',
                }
              },
              //   order: 2,
              //   label: 'Project Name',
              //   className: 'col-md-3',
              {
                order: 3,
                label: 'Phage Storage Plate ID',
                value: 'additional_info.phage_storage_plate_id',
                className: 'col-md-3',
                hideExpression: '${(value1 == "External")}',
                hideExpressionParams: {
                  value1: 'additional_info.paratope_type.value',
                }
              },
              {
                order: 4,
                label: 'Phage Well',
                value: 'additional_info.phage_well',
                className: 'col-md-3',
                hideExpression: '${(value1 == "External")}',
hideExpressionParams: {
  value1: 'additional_info.paratope_type.value',
}
              },
            ],
          },
          {
            type: 'row',
            order: 3,
            contents: [
              {
                order: 1,
                label: 'Antigen Name',
                value: '',
                className: 'col-md-3',
                valueExpression: '${value2?.filter(v=>v).join(", ") || ""}',
                valueExpressionParams: {
                  value2: 'additional_info.antigen[*].antigen.inv_master_name',
                },
                hideExpression: '${(value1 == "External")}',
hideExpressionParams: {
  value1: 'additional_info.paratope_type.value',
}
              },
              {
                order: 2,
                label: 'Parent Antigen ID',
                value: '',
                className: 'col-md-3',
                valueExpression: '${value2?.filter(v=>v).join(", ") || ""}',
                valueExpressionParams: {
                  value2: 'additional_info.antigen[*].parent_antigen_id',
                },
                hideExpression: '${(value1 == "External")}',
hideExpressionParams: {
  value1: 'additional_info.paratope_type.value',
}
              },
              {
                order: 12,
                label: 'Location',
                value: 'inventory_details.location.location',
                className: 'col-md-3',
              },

              //   order: 3,
              //   label: 'L1',
              //   className: 'col-md-3',
              //   hideExpression: '${!(value1)}',
              //   hideExpressionParams: {
              //     value1: 'additional_info.related_project_code'
              //   order: 4,
              //   label: 'L2',
              //   className: 'col-md-3',
              //   hideExpression: '${!(value1)}',
              //   hideExpressionParams: {
              //     value1: 'additional_info.related_project_code'
              //   order: 5,
              //   label: 'L3',
              //   className: 'col-md-3',
              //   hideExpression: '${!(value1)}',
              //   hideExpressionParams: {
              //     value1: 'additional_info.related_project_code'
              //   order: 6,
              //   label: 'H1',
              //   className: 'col-md-3',
              //   hideExpression: '${!(value1)}',
              //   hideExpressionParams: {
              //     value1: 'additional_info.related_project_code'
              //   order: 7,
              //   label: 'H2',
              //   className: 'col-md-3',
              //   hideExpression: '${!(value1)}',
              //   hideExpressionParams: {
              //     value1: 'additional_info.related_project_code'
              //   order: 8,
              //   label: 'H3',
              //   className: 'col-md-3',
              //   hideExpression: '${!(value1)}',
              //   hideExpressionParams: {
              //     value1: 'additional_info.related_project_code'
            ],
          },
          {
            type: 'row',
            order: 4,
            contents: [
              {
                order: 1,
                label: 'Paratope Type',
                value: 'additional_info.paratope_type.value',
                className: 'col-md-3',
              },
              {
                order: 2,
                label: 'Source',
                value: 'additional_info.source',
                className: 'col-md-3',
                hideExpression: '${(value1 != "External")}',
hideExpressionParams: {
  value1: 'additional_info.paratope_type.value',
}
              },
              {
                order: 3,
                label: 'UniProt ID',
                value: 'additional_info.uniprot_id',
                className: 'col-md-3',
                hideExpression: '${(value1 != "External")}',
                hideExpressionParams: {
                  value1: 'additional_info.paratope_type.value',
                }
              },
              {
                order: 4,
                label: 'Antigen Name',
                value: 'additional_info.antigen_e',
                className: 'col-md-3',
                hideExpression: '${(value1 != "External")}',
                hideExpressionParams: {
                  value1: 'additional_info.paratope_type.value',
                }
              },
              {
                order: 4,
                label: 'Variable Heavy Chain Sequence',
                value: 'additional_info.v_h_l_seq',
                className: 'col-md-3',
                hideExpression: '${(value1 != "External")}',
                hideExpressionParams: {
                  value1: 'additional_info.paratope_type.value',
                }
              },
              {
                order: 4,
                label: 'Variable Light Chain Sequence',
                value: 'additional_info.v_l_r_seq',
                className: 'col-md-3',
                hideExpression: '${(value1 != "External")}',
                hideExpressionParams: {
                  value1: 'additional_info.paratope_type.value',
                }
              },
              {
                order: 4,
                label: 'Other Sequence',
                value: 'additional_info.other_seq',
                className: 'col-md-3',
                hideExpression: '${(value1 != "External")}',
                hideExpressionParams: {
                  value1: 'additional_info.paratope_type.value',
                }
              },
              {
                order: 4,
                label: 'Notes/Comments',
                value: 'additional_info.notes_comments',
                className: 'col-md-3',
                hideExpression: '${(value1 != "External")}',
                hideExpressionParams: {
                  value1: 'additional_info.paratope_type.value',
                }
              },
            ], 
          },
          //   order: 4,
          //   defaultValue: 'Selection ID Info',

          {
            type: 'table',
            order: 4,
            hideExpression: '${(value1 == "External")}',
            hideExpressionParams: {
              value1: 'additional_info.paratope_type.value',
            },
            columns: [
              {
                head: {
                  value: '',
                  defaultValue: 'CDR',
                },
                field: {
                  value: 'cdr',
                },
              },
              {
                head: {
                  value: '',
                  defaultValue: 'NUCLEOTIDE SEQUENCE',
                },
                field: {
                  value: 'nucl_sequence',
                },
              },
              {
                head: {
                  value: '',
                  defaultValue: 'AA SEQUENCE',
                },
                field: {
                  value: 'aa_sequence',
                },
              },
            ],
            value: '',
            isExpression2: true,
            valueExpression:
              '[{cdr:"L1",cdr_nuc:"L1_Nuc"}, {cdr:"L2",cdr_nuc:"L2_Nuc"}, {cdr:"L3",cdr_nuc:"L3_Nuc"}, {cdr:"H1",cdr_nuc:"H1_Nuc"}, {cdr:"H2",cdr_nuc:"H2_Nuc"}, {cdr:"H3",cdr_nuc:"H3_Nuc"}].map((key) => { return { cdr: key.cdr,      nucl_sequence: data[key.cdr_nuc],       aa_sequence: data[key.cdr]            };  })',
            valueExpressionParams: {
              data: 'additional_info',
            },
          },

          {
            type: 'header',
            order: 2,
            value: '',
            defaultValue: 'Assign Storage',
            hideExpression: '${(value1 == "External")}',
            hideExpressionParams: {
              value1: 'additional_info.paratope_type.value',
            },
          },
          {
            type: 'storage-table',
            order: 4,
            value: 'additional_info.assigned_storage',
            hideExpression: '${(value1 == "External")}',
            hideExpressionParams: {
              value1: 'additional_info.paratope_type.value',
            },
          },
          {
            type: 'horizontal',
            order: 6,
          },
        ],
        showButton: true,
        buttonText: 'Back To Listing',
      },
    },
  },
  {
    json_code: 'glycerol-stock',
    json_type_id: '55',
    layout: {
      header: {
        text: {
          value: '',
          defaultValue: 'Glycerol Stock',
        },
        showClose: true,
        showPrint: true,
        showDownload: true,
        printText: 'Print',
        downloadText: 'Download AS PDF',
      },
      body: {
        sections: [
          {
            type: 'view-heading-box',
            order: 1,
            value: '',
            valueExpression: 'STOCK ID: ${value2 || "-"}',
            valueExpressionParams: {
              value2: 'inventory_details.inv_item_code',
            },
            className: 'd-flex justify-content-between',
            files: 'additional_info.file_ids',
          },

          {
            type: 'header',
            order: 2,
            value: '',
            defaultValue: 'Vector Information',
          },
          {
            type: 'row',
            order: 3,
            contents: [
              {
                order: 1,
                label: 'Vector Name',
                value: 'additional_info.vector_name.inv_item_name',
                className: 'col-md-3',
              },
              {
                order: 2,
                label: 'No. Of insertion sites',
                value: 'additional_info.vector_name.no_of_insertion_sites',
                className: 'col-md-3',
              },
              {
                order: 3,
                label: 'Insertion Sites',
                value: '',
                className: 'col-md-3',
                valueExpression: '${value2?.filter(v=>v).join(", ") || ""}',
                valueExpressionParams: {
                  value2: 'additional_info.insertion_sites[*].insertion_sites',
                },
              },
              {
                order: 4,
                label: 'Resistance',
                value: 'additional_info.vector_name.resistance.value',
                className: 'col-md-3',
              },
              {
                order: 2,
                label: 'No of Cut Sites',
                value: 'additional_info.vector_name.no_of_cut_sites',
                className: 'col-md-3',
              },
              {
                order: 5,
                label: 'Copy',
                value: 'additional_info.vector_name.copy.value',
                className: 'col-md-3',
              },
            ],
          },
          {
            type: 'header',
            order: 4,
            value: '',
            defaultValue: 'Construct Information',
          },
          {
            type: 'row',
            order: 5,
            contents: [
              {
                order: 1,
                label: 'Construct ID',
                value: 'additional_info.construct_id.inv_item_code',
                className: 'col-md-3',
              },
              {
                order: 2,
                label: 'Designer',
                value: 'additional_info.designer.value',
                className: 'col-md-3',
              },
              {
                order: 3,
                label: 'Order Location',
                value: 'additional_info.order_location.value',
                className: 'col-md-3',
              },
              {
                order: 4,
                label: 'Paratope(s)',
                value: '',
                className: 'col-md-3',
                valueExpression: '${value2?.filter(v=>v).join(", ") || ""}',
                valueExpressionParams: {
                  value2: 'additional_info.paratope[*].inv_item_code',
                },
              },
              {
                order: 5,
                label: 'Format',
                value: 'additional_info.format.value',
                className: 'col-md-3',
              },
              {
                order: 6,
                label: 'Source',
                value: 'additional_info.source',
                className: 'col-md-3',
              },
              {
                order: 7,
                label: 'Insert length',
                value: 'additional_info.insert_length',
                className: 'col-md-3',
              },
              {
                order: 8,
                label: 'Volume Purified (uL)',
                value: 'additional_info.volume_purified',
                className: 'col-md-3',
              },
              {
                order: 9,
                label: 'DNA(ng/µL)',
                value: 'additional_info.dna',
                className: 'col-md-3',
              },
              {
                order: 10,
                label: 'Received Date',
                value: 'additional_info.received_date',
                className: 'col-md-3',
              },
              {
                order: 11,
                label: 'Description',
                value: 'additional_info.construct_description',
                className: 'col-md-12',
              },
              {
                order: 12,
                label: 'Insert Sequence',
                value: 'additional_info.insert_sequence',
                className: 'col-md-12',
              },
              {
                order: 13,
                label: 'Construct Sequence',
                value: 'additional_info.construct_sequence',
                className: 'col-md-12',
              },
            ],
          },
          {
            type: 'header',
            order: 6,
            value: '',
            defaultValue: 'Glycerol Stock Details',
          },
          {
            type: 'row',
            order: 7,
            contents: [
              {
                order: 1,
                label: 'Bacterial Strain',
                value: 'additional_info.bacterial_strain.inv_master_name',
                className: 'col-md-3',
              },
              {
                order: 2,
                label: 'Glycerol %',
                value: 'additional_info.glycerol.value',
                className: 'col-md-3',
              },
              {
                order: 3,
                label: 'Storage Container',
                value: 'additional_info.storage_container.value',
                className: 'col-md-3',
              },
              {
                order: 4,
                label: 'No. Of vials',
                value: 'additional_info.no_of_vials',
                className: 'col-md-3',
              },
              {
                order: 5,
                label: 'Aliquot Vol per vial (ml)',
                value: 'additional_info.aliquot_vol',
                className: 'col-md-3',
              },
              {
                order: 6,
                label: 'Total Vol (ml)',
                value: 'additional_info.total_vol',
                className: 'col-md-3',
              },
              {
                order: 7,
                label: 'Date Of Storage',
                value: 'additional_info.date_of_storage',
                className: 'col-md-3',
              },
            ],
          },
          {
            type: 'header',
            order: 8,
            value: '',
            defaultValue: 'Assign Storage',
          },
          {
            type: 'storage-table',
            order: 5,
            value: 'additional_info.assigned_storage',
          },
          {
            type: 'horizontal',
            order: 6,
          },
          {
            type: 'row',
            order: 8,
            contents: [
              {
                order: 12,
                label: 'Location',
                value: 'inventory_details.location.location',
                className: 'col-md-3',
              },
              {
                order: 1,
                label: 'Notes/Comments',
                value: 'inventory_details.description',
                className: 'col-md-12',
              },
            ],
          },
        ],
        showButton: true,
        buttonText: 'Back To Listing',
      },
    },
  },
  {
    json_code: 'electrocompetent',
    json_type_id: '56',
    layout: {
      header: {
        text: {
          value: '',
          defaultValue: 'Electrocompetent Strain',
        },
        showClose: true,
        showPrint: true,
        showDownload: true,
        printText: 'Print',
        downloadText: 'Download AS PDF',
      },
      body: {
        sections: [
          {
            type: 'view-heading-box',
            order: 1,
            value: '',
            valueExpression: 'EC Source ID: ${(value2 && value3) ? (value2 + "_" + value3) : "value2"}',
            valueExpressionParams: {
              value2: 'additional_info.bac_strain.inv_item_name',
              value3: 'additional_info.batch_date',
            },
            className: 'd-flex justify-content-between',
          },

          {
            type: 'header',
            order: 2,
            value: '',
            defaultValue: 'Strain Information',
          },
          {
            type: 'row',
            order: 3,
            contents: [
              {
                order: 1,
                label: 'Bac Strain',
                value: 'additional_info.bac_strain.inv_item_name',
                className: 'col-md-3',
              },
            ],
          },
          {
            type: 'row',
            order: 4,
            contents: [
              {
                order: 1,
                label: 'Format',
                value: 'additional_info.format.value',
                className: 'col-md-3',
              },
              {
                order: 2,
                label: 'No of EC Vials Prepared',
                value: 'additional_info.no_of_ec_vials',
                className: 'col-md-3',
              },
              {
                order: 3,
                label: 'Vol per Tube (ul)',
                value: 'additional_info.volume_per_tube',
                className: 'col-md-3',
              },
              {
                order: 4,
                label: 'Biosafety Level',
                value: 'additional_info.bio_safety_level.value',
                className: 'col-md-3',
              },
              {
                order: 5,
                label: 'Expiry Date',
                value: 'additional_info.expiry_date',
                className: 'col-md-3',
              },
              {
                order: 6,
                label: 'Storage Temp (°C)',
                value: 'additional_info.storage_temp.value',
                className: 'col-md-3',
              },
              {
                order: 7,
                label: 'Batch Date',
                value: 'additional_info.batch_date',
                className: 'col-md-3',
              },
              {
                order: 8,
                label: 'Date Of Storage',
                value: 'additional_info.date_of_storage',
                className: 'col-md-3',
              },
              {
                order: 12,
                label: 'Location',
                value: 'inventory_details.location.location',
                className: 'col-md-3',
              },
            ],
          },
          {
            type: 'header',
            order: 5,
            value: '',
            defaultValue: 'Assign Storage',
          },
          {
            type: 'storage-table',
            order: 6,
            value: 'additional_info.assigned_storage',
          },
          {
            type: 'horizontal',
            order: 7,
          },
          {
            type: 'row',
            order: 8,
            contents: [
              {
                order: 1,
                label: 'Notes/Comments',
                value: 'inventory_details.description',
                className: 'col-md-12',
              },
            ],
          },
        ],
        showButton: true,
        buttonText: 'Back To Listing',
      },
    },
  },
  {
    json_code: 'Oligos',
    json_type_id: '57',
    layout: {
      header: {
        text: {
          value: '',
          valueExpression: '${value1}',
          valueExpressionParams: {
            value1: 'inventory_details.inv_master.inv_master_name',
          },
        },
        showClose: true,
        showPrint: true,
        showDownload: true,
        printText: 'Print',
        downloadText: 'Download AS PDF',
      },
      body: {
        sections: [
          {
            type: 'view-heading-box',
            order: 1,
            value: 'inventory_details.inv_master.inv_master_name',
            className: 'd-flex ',
            files: 'additional_info.file_ids',
          },
          {
            additionalData: [
              {
                order: 1,
                label: 'Oligo ID :',
                value: 'inventory_details.inv_master.inv_master_id',
              },
            ],
          },
          {
            type: 'header',
            order: 2,
            value: '',
            defaultValue: 'Oligo Information',
          },
          {
            type: 'row',
            order: 3,
            contents: [
              {
                order: 1,
                label: 'Oligo Id',
                value: 'inventory_details.inv_master.inv_master_name',
                className: 'col-md-3',
              },
              {
                order: 3,
                label: 'Oligo Type',
                value: 'additional_info.oligo_type.value',
                className: 'col-md-3',
              },
              {
                order: 3,
                label: 'Sequence Type',
                value: 'additional_info.sequencing_type.value',
                className: 'col-md-3',
                hideExpression: '${!(value1)}',
                hideExpressionParams: {
                  value1: 'additional_info.sequencing_type',
                },
              },
              {
                order: 19,
                label: 'Description',
                value: 'inventory_details.inv_master.inv_master_description',
                className: 'col-md-3',
              },
              {
                order: 2,
                label: 'Order Quantity',
                value: 'additional_info.order_quantity',
                className: 'col-md-3',
              },

              {
                order: 3,
                label: 'Vendor',
                value: 'additional_info.vendor.vendor_name',
                className: 'col-md-3',
              },
              {
                order: 4,
                label: 'Conc(ng)',
                value: 'additional_info.conc',
                className: 'col-md-3',
              },
              {
                order: 5,
                label: 'Dilution Volume(ul)',
                value: 'additional_info.dilution_vol',
                className: 'col-md-3',
              },
              {
                order: 6,
                label: 'Final Conc(ng/ul)',
                value: 'additional_info.final_conc',
                className: 'col-md-3',
              },
              {
                order: 7,
                label: 'Order Date',
                value: 'additional_info.order_date',
                className: 'col-md-3',
              },
              {
                order: 18,
                label: 'Date of Storage',
                value: 'additional_info.date_of_storage',
                className: 'col-md-3',
              },
              {
                order: 1,
                label: 'Sequence',
                value: 'additional_info.sequence',
                className: 'col-md-12',
              },
              {
                order: 12,
                label: 'Location',
                value: 'inventory_details.location.location',
                className: 'col-md-3',
              },
              //   order: 20,
              //   label: 'Notes/Comments',
              //   className: 'col-md-6',
            ],
          },
          {
            type: 'header',
            order: 2,
            value: '',
            defaultValue: 'Assign Storage',
          },
          {
            type: 'storage-table',
            order: 4,
            value: 'additional_info.assigned_storage',
          },
          {
            type: 'horizontal',
            order: 6,
          },
          {
            type: 'row',
            order: 8,
            contents: [
              {
                order: 2,
                label: 'Notes/Comments',
                value: 'inventory_details.description',
                className: 'col-md-12',
              },
            ],
          },
        ],
        showButton: true,
        buttonText: 'Back To Listing',
      },
    },
  },
  {
    json_code: 'cell-lines',
    json_type_id: '35',
    layout: {
      header: {
        text: {
          valueExpression: '${value1 + (value2? " - "+value2:"")}',
          valueExpressionParams: {
            value1: 'inventory_details.inv_master.inv_master_name',
            value2: 'additional_info.vendor_collaborator.value',
          },
        },
        showClose: true,
        showPrint: true,
        showDownload: true,
        printText: 'Print',
        downloadText: 'Download AS PDF',
      },
      body: {
        sections: [
          {
            type: 'view-heading-box',
            order: 1,
            value: 'inventory_details.inv_master.inv_master_name',
            className: 'd-flex justify-content-between',
            files: 'additional_info.file_ids',
            additionalData: [
              {
                order: 1,
                label: 'Cell Line ID :',
                value: 'inventory_details.inv_item_id',
              },
            ],
          },

          {
            type: 'header',
            order: 2,
            value: '',
            defaultValue: 'Cell Line  Information',
          },
          {
            type: 'row',
            order: 3,
            contents: [
              {
                order: 1,
                label: 'Cell Line Category',
                value: 'additional_info.type_desc.value',
                className: 'col-md-3',
                // hideExpression: '${!(value1 == "Commercial")}',
                // hideExpressionParams: {
                //   value1: 'additional_info.source.value'
              },
              {
                order: 2,
                label: 'Cell Line Name',
                value: 'inventory_details.inv_master.inv_master_name',
                className: 'col-md-3',
                // hideExpression: '${!(value1 == "Commercial")}',
                // hideExpressionParams: {
                //   value1: 'additional_info.source.value'
              },
              {
                order: 3,
                label: 'Media',
                value: 'additional_info.media',
                className: 'col-md-3',
              },
              {
                order: 4,
                label: 'Species',
                value: 'additional_info.species',
                className: 'col-md-3',
              },
              {
                order: 5,
                label: 'Source Tissue',
                value: 'additional_info.source_tissue',
                className: 'col-md-3',
              },
              {
                order: 6,
                label: 'Cancer Type',
                value: 'additional_info.cancer_type',
                className: 'col-md-3',
              },
              {
                order: 7,
                label: 'SubType',
                value: 'additional_info.sub_type',
                className: 'col-md-3',
              },
              {
                order: 8,
                label: 'Reported Morphology',
                value: 'additional_info.reported_morphology',
                className: 'col-md-3',
              },
              {
                order: 9,
                label: 'Reported Doubling Time (hrs)',
                value: 'additional_info.reported_doubling_time',
                className: 'col-md-3',
              },

              {
                order: 10,
                label: 'BSL Level',
                value: 'additional_info.bsl_level',
                className: 'col-md-3',
              },
              {
                order: 11,
                label: 'Resistance',
                value: 'additional_info.resistance',
                className: 'col-md-3',
              },
              {
                order: 12,
                label: 'Literature Characterisation',
                value: 'additional_info.literature_characterisation',
                className: 'col-md-3',
              },
              {
                order: 13,
                label: 'Vendor/Collaborator',
                value: 'additional_info.vendor_collaborator.value',
                className: 'col-md-3',
              },

              {
                order: 14,
                label: 'Catalog NUmber/ID',
                value: 'additional_info.catalog_no',
                className: 'col-md-3',
              },
              {
                order: 15,
                label: 'Product URL',
                value: 'additional_info.product_url',
                className: 'col-md-6',
              },
              {
                order: 16,
                label: 'Passage',
                value: 'additional_info.passage',
                className: 'col-md-3',
              },
              {
                order: 17,
                label: 'Viability %',
                value: 'additional_info.viability',
                className: 'col-md-3',
              },
              {
                order: 18,
                label: 'Mycoplasma Test (+/- and date)',
                value: 'additional_info.mycoplasma_test.value',
                className: 'col-md-3',
              },
              {
                order: 19,
                label: '   ',
                value: 'additional_info.mycoplasma_test_date',
                className: 'col-md-3',
              },
              {
                order: 20,
                label: 'Morphology',
                value: 'additional_info.morphology',
                className: 'col-md-3',
              },
              {
                order: 21,
                label: 'Doubling Time(hr)',
                value: 'additional_info.doubling_time',
                className: 'col-md-3',
              },
              {
                order: 22,
                label: 'No of Vials',
                value: 'additional_info.no_of_vials',
                className: 'col-md-3',
              },
              {
                order: 23,
                label: 'Cell Count Per Vial',
                value: 'additional_info.cell_count_per_vial',
                className: 'col-md-3',
              },
              {
                order: 24,
                label: 'Vol Per Vial (µL)',
                value: 'additional_info.vol_per_vial',
                className: 'col-md-3',
              },
              {
                order: 25,
                label: 'Received Date',
                value: 'additional_info.received_date',
                className: 'col-md-3',
              },
              {
                order: 26,
                label: 'Date of Storage',
                value: 'additional_info.date_of_storage',
                className: 'col-md-3',
              },
              {
                order: 12,
                label: 'Location',
                value: 'inventory_details.location.location',
                className: 'col-md-3',
              },
            ],
          },
          {
            type: 'header',
            order: 2,
            value: '',
            defaultValue: 'Assign Storage',
          },
          {
            type: 'storage-table',
            order: 4,
            value: 'additional_info.assigned_storage',
          },
          {
            type: 'horizontal',
            order: 6,
          },
          {
            type: 'row',
            order: 8,
            contents: [
              {
                order: 1,
                label: 'Description',
                value: 'inventory_details.description',
                className: 'col-md-12',
              },
            ],
          },
        ],
        showButton: true,
        buttonText: 'Back To Listing',
      },
    },
    layout_master: {
      header: {
        text: {
          valueExpression: '${value1 + (value2? " - "+value2:"")}',
          valueExpressionParams: {
            value1: 'master_details.name',
            value2: 'additional_info.type_desc.value',
          },
        },
        showClose: true,
        showPrint: true,
        showDownload: true,
        printText: 'Print',
        downloadText: 'Download AS PDF',
      },
      body: {
        sections: [
          {
            type: 'view-heading-box',
            order: 1,
            value: 'master_details.name',
            className: 'd-flex justify-content-between',
            files: 'additional_info.file_ids',
          },

          {
            type: 'header',
            order: 2,
            value: '',
            defaultValue: 'Cell Line  Information',
            files: 'additional_info.file_ids',
          },
          {
            type: 'row',
            order: 3,
            contents: [
              {
                order: 1,
                label: 'Media',
                value: 'additional_info.media.inv_master_name',
                className: 'col-md-3',
              },
              {
                order: 2,
                label: 'Species',
                value: 'additional_info.species.value',
                className: 'col-md-3',
              },
              {
                order: 3,
                label: 'Source Tissue',
                value: 'additional_info.source_tissue.value',
                className: 'col-md-3',
              },
              {
                order: 4,
                label: 'Cancer Type',
                value: 'additional_info.cancer_type.value',
                className: 'col-md-3',
              },
              {
                order: 5,
                label: 'Subtype',
                value: 'additional_info.sub_type.value',
                className: 'col-md-3',
              },
              {
                order: 6,
                label: 'Reported Morphology',
                value: 'additional_info.reported_morphology.value',
                className: 'col-md-3',
              },
              {
                order: 7,
                label: 'Reported Doubling Time (hrs)',
                value: 'additional_info.reported_doubling_time.value',
                className: 'col-md-3',
              },
              {
                order: 8,
                label: 'BSL Level',
                value: 'additional_info.bsl_level.value',
                className: 'col-md-3',
              },
              {
                order: 9,
                label: 'Resistance',
                value: 'additional_info.resistance.value',
                className: 'col-md-3',
              },
              {
                order: 10,
                label:
                  'Literature Characterisation<span class="info-icon"><div class="custom-tooltip"><p>Expression profiles, Autocrine activation, Mutational status, Drug sensitivity etc with DOI</p></div></span>',
                value: 'additional_info.literature_characterisation',
                className: 'col-md-6',
              },
              {
                order: 11,
                label: 'Notes/ Comments',
                value: 'master_details.desc',
                className: 'col-md-12',
              },
              {
                order: 12,
                label: 'Location',
                value: 'master_details.location.location',
                className: 'col-md-3',
              },
            ],
          },
          {
            type: 'horizontal',
            order: 6,
          },
        ],
        showButton: true,
        buttonText: 'Back To Listing',
      },
    },
  },
  {
    json_code: 'antigens',
    json_type_id: '58',
    layout: {
      header: {
        text: {
          value: '',
          defaultValue: 'Antigens',
        },
        showClose: true,
        showPrint: true,
        showDownload: true,
        printText: 'Print',
        downloadText: 'Download AS PDF',
      },
      body: {
        sections: [
          {
            type: 'view-heading-box',
            order: 1,
            value: '',
            valueExpression: 'Antigen ID: ${value2 || "-"}',
            valueExpressionParams: {
              value2: 'inventory_details.inv_item_code',
            },
            className: 'd-flex justify-content-between',
            files: 'additional_info.file_ids',
          },
          {
            type: 'row',
            order: 3,
            contents: [
              {
                order: 1,
                label: 'Antigen Name',
                value: 'inventory_details.inv_master.inv_master_name',
                className: 'col-md-3',
              },
            ],
          },
          {
            type: 'row',
            order: 4,
            contents: [
              {
                order: 1,
                label: 'Source Of Antigen',
                value: 'additional_info.antigen_source.value',
                className: 'col-md-3',
              },
            ],
          },
          {
            type: 'row',
            order: 5,
            contents: [
              //   order: 1,
              //   label: 'In House Antigen ID',
              //   className: 'col-md-3',
              //   hideExpression: '${(value2 == "Commercial")}',
              //   hideExpressionParams: {
              //     value2: 'additional_info.antigen_source.value'
              //   order: 2,
              //   label: 'Gene Name',
              //   className: 'col-md-3'
              {
                order: 3,
                label: 'Expression system',
                value: 'additional_info.exp_system',
                className: 'col-md-3',
              },
            ],
          },
          {
            type: 'row',
            order: 6,
            contents: [
              {
                order: 1,
                label: 'Tags',
                value: 'additional_info.tags',
                className: 'col-md-3',
              },
              {
                order: 2,
                label: 'Antigen AA Boundary',
                value: 'additional_info.aa_boundary',
                className: 'col-md-3',
              },
              {
                order: 3,
                label: 'Calculated Mol Wt (kDa)',
                value: 'additional_info.calculated_mol',
                className: 'col-md-3',
                hideExpression: '${(value2 == "In House")}',
                hideExpressionParams: {
                  value2: 'additional_info.antigen_source.value',
                },
              },
              {
                order: 3,
                label: 'Uniprot ID',
                value: 'additional_info.uniprot_id',
                className: 'col-md-3',
              },
              {
                order: 4,
                label: 'Conc (µg/ml)',
                value: 'additional_info.conc',
                className: 'col-md-3',
                hideExpression: '${(value2 == "In House")}',
                hideExpressionParams: {
                  value2: 'additional_info.antigen_source.value',
                },
              },
              {
                order: 4,
                label: 'Conc (mg/ml)',
                value: 'additional_info.conc',
                className: 'col-md-3',
                hideExpression: '${(value2 == "Commercial")}',
                hideExpressionParams: {
                  value2: 'additional_info.antigen_source.value',
                },
              },
              {
                order: 5,
                label: 'Observed Mol Wt(kDa)',
                value: 'additional_info.observed_mol',
                className: 'col-md-3',
                hideExpression: '${(value2 == "In House")}',
                hideExpressionParams: {
                  value2: 'additional_info.antigen_source.value',
                },
              },
              {
                order: 6,
                label: 'Purity(%)',
                value: 'additional_info.purity',
                className: 'col-md-3',
              },
              {
                order: 7,
                label: 'Format',
                value: 'additional_info.format.value',
                className: 'col-md-3',
              },
              {
                order: 8,
                label: 'No of vials',
                value: 'additional_info.no_of_vials',
                className: 'col-md-3',
              },
              {
                order: 9,
                label: 'Volume per vial (µl)',
                value: 'additional_info.vol_per_vial',
                className: 'col-md-3',
              },
              {
                order: 10,
                label: 'Date of storage',
                value: 'additional_info.date_of_storage',
                className: 'col-md-3',
              },
              {
                order: 10,
                label: 'Constructs Selection',
                value: 'additional_info.constructs_selection.inv_item_code',
                className: 'col-md-3',
              },
              {
                order: 10,
                label: 'Lot/batch Number',
                value: 'additional_info.lot_batch_number',
                className: 'col-md-3',
                hideExpression: '${(value2 == "In House")}',
                hideExpressionParams: {
                  value2: 'additional_info.antigen_source.value',
                },
              },
              {
                order: 10,
                label: 'Price',
                value: 'additional_info.price',
                className: 'col-md-3',
                hideExpression: '${(value2 == "In House")}',
                hideExpressionParams: {
                  value2: 'additional_info.antigen_source.value',
                },
              },
              {
                order: 10,
                label: 'Currency',
                value: 'additional_info.currency.value',
                className: 'col-md-3',
                hideExpression: '${(value2 == "In House")}',
                hideExpressionParams: {
                  value2: 'additional_info.antigen_source.value',
                },
              },
              {
                order: 10,
                label: 'Purchase Date',
                value: 'additional_info.purchase_date',
                className: 'col-md-3',
                hideExpression: '${(value2 == "In House")}',
                hideExpressionParams: {
                  value2: 'additional_info.antigen_source.value',
                },
              },
              {
                order: 10,
                label: 'Received Date',
                value: 'additional_info.received_date',
                className: 'col-md-3',
                hideExpression: '${(value2 == "In House")}',
                hideExpressionParams: {
                  value2: 'additional_info.antigen_source.value',
                },
              },
              {
                order: 12,
                label: 'Location',
                value: 'inventory_details.location.location',
                className: 'col-md-3',
              },
            ],
          },
          {
            type: 'row',
            order: 7,
            contents: [
              {
                order: 1,
                label: 'Vendor',
                value: 'additional_info.vendor.vendor_name',
                className: 'col-md-3',
                hideExpression: '${(value2 !== "Commercial")}',
                hideExpressionParams: {
                  value2: 'additional_info.antigen_source.value',
                },
              },
              {
                order: 2,
                label: 'Catalog Number',
                value: 'additional_info.catalogue_no',
                className: 'col-md-3',
                hideExpression: '${(value2 !== "Commercial")}',
                hideExpressionParams: {
                  value2: 'additional_info.antigen_source.value',
                },
              },
              {
                order: 3,
                label: 'Vendor URL',
                value: 'additional_info.vendor_url',
                className: 'col-md-3',
                hideExpression: '${(value2 !== "Commercial")}',
                hideExpressionParams: {
                  value2: 'additional_info.antigen_source.value',
                },
              },
            ],
          },
          {
            type: 'header',
            order: 4,
            value: '',
            defaultValue: 'Assign Storage',
          },
          {
            type: 'storage-table',
            order: 5,
            value: 'additional_info.assigned_storage',
          },
          {
            type: 'horizontal',
            order: 6,
          },
          {
            type: 'row',
            order: 8,
            contents: [
              {
                order: 1,
                label: 'Notes/Comments',
                value: 'inventory_details.description',
                className: 'col-md-12',
              },
            ],
          },
        ],
        showButton: true,
        buttonText: 'Back To Listing',
      },
    },
    layout_master: {
      header: {
        text: {
          value: '',
          defaultValue: 'Antigens',
        },
        showClose: true,
        showPrint: true,
        showDownload: true,
        printText: 'Print',
        downloadText: 'Download AS PDF',
      },
      body: {
        sections: [
          {
            type: 'view-heading-box',
            order: 1,
            value: 'master_details.name',
            className: 'd-flex justify-content-between',
            files: 'additional_info.file_ids',
            // additionalData: [
            //     order: 1,
            //     label: 'Cell Line ID :',
          },

          {
            type: 'header',
            order: 2,
            value: '',
            defaultValue: 'Antigen Information',
          },
          {
            type: 'row',
            order: 3,
            contents: [
              {
                order: 11,
                label: 'Antigen Name',
                value: 'master_details.name',
                className: 'col-md-3',
              },
              {
                order: 9,
                label: 'Uniprot ID',
                value: 'additional_info.uniprot_id',
                className: 'col-md-3',
              },
              {
                order: 9,
                label: 'Tags',
                value: 'additional_info.tags',
                className: 'col-md-3',
              },
              {
                order: 9,
                label: 'AA Boundary',
                value: 'additional_info.aa_boundary',
                className: 'col-md-3',
              },
            ],
          },

          {
            type: 'horizontal',
            order: 6,
          },
          {
            type: 'row',
            order: 12,
            contents: [
              {
                order: 12,
                label: 'Location',
                value: 'master_details.location.location',
                className: 'col-md-3',
              },
              {
                order: 1,
                label: 'Description',
                value: 'master_details.desc',
                className: 'col-md-12',
              },
            ],
          },
        ],
        showButton: true,
        buttonText: 'Back To Listing',
      },
    },
  },
  {
    json_code: 'library',
    json_type_id: '59',
    layout: {
      header: {
        text: {
          valueExpression: '${value1 + (value2? " - "+value2:"")}',
          valueExpressionParams: {
            value1: 'inventory_details.inv_master.inv_master_name',
            value2: 'additional_info.vendor_collaborator.value',
          },
        },
        showClose: true,
        showPrint: true,
        showDownload: true,
        printText: 'Print',
        downloadText: 'Download AS PDF',
      },
      body: {
        sections: [
          {
            type: 'view-heading-box',
            order: 1,
            value: 'inventory_details.inv_master.inv_master_name',
            className: 'd-flex justify-content-between',
            files: 'additional_info.file_ids',
            otherFileType: 'oligos_sequence',
            additionalData: [
              {
                order: 1,
                label: 'Library ID :',
                value: 'inventory_details.inv_item_code',
              },
            ],
          },
          {
            type: 'header',
            order: 2,
            value: '',
            defaultValue: 'Template Information',
          },
          {
            type: 'row',
            order: 3,
            contents: [
              {
                order: 1,
                label: 'Project ID',
                value: 'additional_info.project_id',
                className: 'col-md-3',
                // hideExpression: '${!(value1?.length)}',
                // hideExpressionParams: {
                //   value1: 'additional_info.ref_project_id',
              },
              {
                order: 2,
                label: 'Project Name',
                value: 'additional_info.project_name',
                className: 'col-md-3',
                // hideExpression: '${!(value1?.length)}',
                // hideExpressionParams: {
                //   value1: 'additional_info.ref_project_id',
              },
              {
                order: 3,
                label: 'Requested By',
                value: 'additional_info.requested_by.full_name',
                className: 'col-md-3',
              },
              {
                order: 4,
                label: 'Scientist',
                value: 'additional_info.scientist',
                className: 'col-md-3',
              },
              {
                order: 5,
                label: 'Elution Vol (μL)',
                value: 'additional_info.elution_vol',
                className: 'col-md-3',
              },
              {
                order: 6,
                label: 'DNA Conc (ng/μL)',
                value: 'additional_info.dna_conc',
                className: 'col-md-3',
              },
              {
                order: 7,
                label: 'Yield (ng)',
                value: 'additional_info.yield',
                className: 'col-md-3',
              },
              {
                order: 8,
                label: 'Selection ID',
                value: 'additional_info.screening_id',
                className: 'col-md-3',
              },
              //   order: 9,
              //   label: 'Clone Plate ID',
              //   className: 'col-md-3',
              //   hideExpression: '${!(value1 == "Paratope")}',
              //   order: 10,
              //   label: 'Clone Picked',
              //   className: 'col-md-3',
            ],
          },
          {
            type: 'table',
            order: 4,
            columns: [
              {
                head: {
                  value: '',
                  defaultValue: 'TEMPLATE NAME',
                },
                field: {
                  value: 'template_name',
                },
              },
              {
                head: {
                  value: '',
                  defaultValue: 'STOP CODONS',
                },
                field: {
                  key: 'stop_codons',
                  isExpression2: true,
                  isRepeatedCols: true,
                  value: '',
                  valueExpression: 'value1?.map(v=>v.stop_codons)',
                  valueExpressionParams: {
                    value1: 'stop_codons_list',
                  },
                },
              },
              {
                head: {
                  value: '',
                  defaultValue: 'OLIGOS USED',
                },
                field: {
                  key: 'oligos_used',
                  isExpression2: true,
                  isRepeatedCols: true,
                  nestedLevel: 2,
                  value: '',
                  valueExpression:
                    'value1?.map(v=>v.oligos_used)?.map(v1=>v1?.flatMap(v2=>v2.inv_master_name)?.filter(v=>v))',
                  valueExpressionParams: {
                    value1: 'oligos_used_list',
                  },
                },
              },
              {
                head: {
                  value: '',
                  defaultValue: 'SEQUENCE',
                },
                field: {
                  key: 'sequence',
                  isExpression2: true,
                  isRepeatedCols: true,
                  nestedLevel: 2,
                  value: '',
                  valueExpression: 'value1?.map(v=>v.oligos_used)?.map(v1=>v1?.flatMap(v2=>v2.sequence)?.filter(v=>v))',
                  valueExpressionParams: {
                    value1: 'oligos_used_list',
                  },
                },
              },
            ],
            value: 'additional_info.template_arr',
          },
          {
            type: 'header',
            order: 5,
            value: '',
            defaultValue: 'Library Info',
          },
          {
            type: 'row',
            order: 6,
            contents: [
              {
                order: 1,
                label: 'Library ID',
                value: 'additional_info.libaray_id',
                className: 'col-md-3',
              },
              //   order: 2,
              //   label: 'Description',
              //   className: 'col-md-3',
              {
                order: 3,
                label: 'Diversity',
                value: 'additional_info.diversity',
                className: 'col-md-3',
              },
              //   order: 4,
              //   label: 'Phage Titre',
              //   className: 'col-md-3',
              {
                order: 5,
                label: 'Functional Clones % Test Clones Site Mutated',
                value: 'additional_info.functional_clone',
                className: 'col-md-4',
              },
              {
                order: 6,
                label: 'Primer Incorporation % Test Clone Site Mutated',
                value: 'additional_info.primer_incorporation',
                className: 'col-md-4',
              },
              {
                order: 7,
                label: 'Pooled Elisa Status',
                value: 'additional_info.pooled_elisa_status.value',
                className: 'col-md-3',
              },
            ],
          },
          {
            type: 'header',
            order: 7,
            value: '',
            defaultValue: 'Library Stock Info',
          },
          {
            type: 'row',
            order: 8,
            contents: [
              {
                order: 1,
                label: 'Glycerol %',
                value: 'additional_info.glycerol.value',
                className: 'col-md-3',
              },
              {
                order: 2,
                label: 'Tubetype',
                value: 'additional_info.tube_type.value',
                className: 'col-md-3',
              },
              {
                order: 3,
                label: 'Date of Storage',
                value: 'additional_info.date_of_storage',
                className: 'col-md-3',
              },
              {
                order: 4,
                label: 'No of Vials',
                value: 'additional_info.no_of_vials',
                className: 'col-md-3',
              },
              {
                order: 5,
                label: 'Aliquot Vol',
                value: 'additional_info.aliquot_vol',
                className: 'col-md-3',
              },
              {
                order: 6,
                label: 'Total vol(ml)',
                value: 'additional_info.total_vol',
                className: 'col-md-3',
              },
              {
                order: 12,
                label: 'Location',
                value: 'inventory_details.location.location',
                className: 'col-md-3',
              },
            ],
          },
          {
            type: 'header',
            order: 9,
            value: '',
            defaultValue: 'Assign Storage',
          },
          {
            type: 'storage-table',
            order: 10,
            value: 'additional_info.assigned_storage',
          },
          {
            type: 'horizontal',
            order: 11,
          },
          {
            type: 'row',
            order: 12,
            contents: [
              {
                order: 1,
                label: 'Notes/Comments',
                value: 'inventory_details.description',
                className: 'col-md-12',
              },
            ],
          },
        ],
        showButton: true,
        buttonText: 'Back To Listing',
      },
    },
    layout_master: {
      header: {
        text: {
          value: '',

          valueExpression: '${value1 + (value2? (" - "+value2): "")}',
          valueExpressionParams: {
            value1: 'master_details.name',
            value2: 'additional_info.paratope_id',
            // value3: 'additional_info.paratope_id',
          },
        },
        showClose: true,
        showPrint: true,
        showDownload: true,
        printText: 'Print',
        downloadText: 'Download AS PDF',
      },
      body: {
        sections: [
          {
            type: 'view-heading-box',
            order: 1,
            value: 'master_details.name',
            className: 'd-flex justify-content-between',
            files: 'additional_info.file_ids',
            // additionalData: [
            //     order: 1,
            //     label: 'Cell Line ID :',
          },

          {
            type: 'header',
            order: 2,
            value: '',
            defaultValue: 'Library Information',
          },
          {
            type: 'row',
            order: 3,
            contents: [
              {
                order: 1,
                label: 'Project ID',
                value: 'additional_info.project_id',
                className: 'col-md-3',
              },
              {
                order: 2,
                label: 'Project Name',
                value: 'master_details.name',
                className: 'col-md-3',
              },
              //   order: 1,
              //   label: 'Parent Clone',
              //   className: 'col-md-3',
              //   hide: true,
              //   hideExpression: '${!(value1 == "Parent Clone")}',
              //   hideExpressionParams: {
              //     value1: 'additional_info.type_desc.value',
              {
                order: 3,
                label: 'Paratope',
                value: 'additional_info.paratope_id',
                className: 'col-md-3',
                // hide: true,
                // hideExpression: '${!(value1 == "Paratope")}',
                // hideExpressionParams: {
                //   value1: 'additional_info.type_desc.value',
              },
              {
                order: 4,
                label: 'Selection ID',
                value: 'additional_info.screening_id',
                className: 'col-md-3',
                // hide: true,
                // hideExpression: '${!(value1 == "Paratope")}',
                // hideExpressionParams: {
                //   value1: 'additional_info.type_desc.value',
              },
              //   order: 4,
              //   label: 'Clone Plate ID',
              //   className: 'col-md-3',
              //   hide: true,
              //   hideExpression: '${!(value1 == "Paratope")}',
              //   hideExpressionParams: {
              //     value1: 'additional_info.type_desc.value',
              //   order: 5,
              //   label: 'Clones Picked',
              //   className: 'col-md-3',
              //   hide: true,
              //   hideExpression: '${!(value1 == "Paratope")}',
              //   hideExpressionParams: {
              //     value1: 'additional_info.type_desc.value',

              //   order: 18,
              //   label: 'Description',
              //   className: 'col-md-12',

            ],
          },
          {
            type: 'table',
            order: 5,
            columns: [
              {
                head: {
                  value: '',
                  defaultValue: 'TEMPLATE NAME',
                },
                field: {
                  value: 'template_name',
                },
              },
              {
                head: {
                  value: '',
                  defaultValue: 'STOP CODONS',
                },
                field: {
                  key: 'stop_codons',
                  isExpression2: true,
                  value: '',
                  valueExpression: 'value1.join(", ")',
                  valueExpressionParams: {
                    value1: 'stop_codons',
                  },
                },
              },
            ],
            value: 'additional_info.template_arr',
          },
          //   order: 2,
          //   defaultValue: 'Assign Storage',
          //   order: 4,
          {
            type: 'horizontal',
            order: 6,
          },
          {
            type: 'row',
            order: 7,
            contents: [
              {
                order: 1,
                label: 'Location',
                value: 'master_details.location.location',
                className: 'col-md-3',
              },
              {
                order: 2,
                label: 'Notes/Comments',
                value: 'master_details.desc',
                className: 'col-md-12',
              },
            ],
          },
        ],
        showButton: true,
        buttonText: 'Back To Listing',
      },
    },
  },
];
